import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelDialog, IcepanelDialogData } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { IcecontrolSettings, IcepanelSettings, IcepanelsectionSettings, PaymentMethods } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { otheritemsjournal } from '../../../../icemedx-lib/src/models/accounting/otheritemsjournal';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { servicepaymentreference } from '../../../../icemedx-lib/src/models/accounting/servicepaymentreference';
import { superbillindex } from '../../../../icemedx-lib/src/models/accounting/superbillindex';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { licenseobject } from '../../../../icemedx-lib/src/models/domain/license';
import { orderobject } from '../../../../icemedx-lib/src/models/domain/order';
import { orderdetailobject } from '../../../../icemedx-lib/src/models/domain/orderdetail';
import { payer } from '../../../../icemedx-lib/src/models/domain/payer';
import { paymentrequest } from '../../../../icemedx-lib/src/models/domain/paymentrequest';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { provider_index } from '../../../../icemedx-lib/src/models/domain/provider_index';
import { provider_reference } from '../../../../icemedx-lib/src/models/domain/provider_reference';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { subscriptionobject } from '../../../../icemedx-lib/src/models/domain/subscription';
import { vendor } from '../../../../icemedx-lib/src/models/domain/vendor';
import { diagnosis } from '../../../../icemedx-lib/src/models/ehr/diagnosis';
import { encounter } from '../../../../icemedx-lib/src/models/ehr/encounter';
import { encounterprogressnotes } from '../../../../icemedx-lib/src/models/ehr/encounterprogressnotes';
import { externaldata } from '../../../../icemedx-lib/src/models/ehr/externaldata';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { basecodereference } from '../../../../icemedx-lib/src/models/ehr/subs/basecodereference';
import { diagnosisreference } from '../../../../icemedx-lib/src/models/ehr/subs/diagnosisreference';
import { externaldatareference } from '../../../../icemedx-lib/src/models/ehr/subs/externaldatareference';
import { subscriberreference } from '../../../../icemedx-lib/src/models/ehr/subs/subscriberreference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { message } from '../../../../icemedx-lib/src/models/messages/message';
import { messagereference } from '../../../../icemedx-lib/src/models/messages/messagereference';
import { otheritemsindex } from '../../../../icemedx-lib/src/models/otheritems/otheritemsindex';
import { otheritemsreceiving } from '../../../../icemedx-lib/src/models/otheritems/otheritemsreceiving';
import { logmessage } from '../../../../icemedx-lib/src/models/system/logmessage';
import { LogReport } from '../../../../icemedx-lib/src/models/system/LogReport';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { AppService } from '../app.service';
import { BreadcrumType } from '../../../../icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';
import { AppConstants } from '../app-constants';

declare var require: any;
let currentEnv: any = require("../../../../../env.json").currentEnv;

const csBalance = 1;
const csCGL = 2;
const csPayment = 3;
const csSummary = 4;

const DefaultPostingImage: string = "./assets/default_blog_image.png";
const FileUploadClicked: string = "FileUploadClicked";

const diagCount = 8;

@Component({
  selector: 'app-outstandingaccountbalance',
  templateUrl: './outstandingaccountbalance.component.html',
  styleUrls: ['./outstandingaccountbalance.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class OutstandingaccountbalanceComponent implements OnInit {
  // Data Members
  serviceCharges: superbillcharges = null;
  chargeList: medicalservice[] = [];
  newCharge: medicalservice = null;
  patientSubscribers: subscriber[] = [];
  patientSubRefs: subscriberreference[] = [];
  pyrCovs: any[] = [];
  responsibleParties: any[] = [];
  networkProviders: provider_index[] = [];

  // Current Change Members
  currentCharge: any = {};
  currentChargePanel: IcepanelSettings = new IcepanelSettings("", "", "", "", []);
  currentChargeHistory: chargehistory = new chargehistory(null);

  payPost: payment = null;
  totalTax: number = 0.0;
  totalDue: number = 0.0;
  remainingBalance: number = 0.0;
  partyBuckets: any = {};

  // Currency and Currencies
  countries: basecode[] = [];
  currencies: basecode[] = [];
  listOfModifiers: basecode[] = [];
  listOfPayerResponsibities: basecode[] = [];

  listOfMessages: message[] = [];

  // NAV Vars
  step: number = csBalance;
  currentCGL: number = 0;

  listOfServices = [];
  listOfInventory = [];

  outStandingBalanceHeader: IcepanelSettings = null;
  outStandingBalanceFormGrp: FormGroup = null;

  billToStatus: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillToStatus", "Status of Service Bucket")
    .setControlName("BillToStatus")
    .createFormControl(0, [Validators.required]);

  diag1Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag1", "Diagnosis A")
    .setControlName("Diag1")
    .createFormControl("", []);

  diag2Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag2", "Diagnosis B")
    .setControlName("Diag2")
    .createFormControl("", []);

  diag3Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag3", "Diagnosis C")
    .setControlName("Diag3")
    .createFormControl("", []);

  diag4Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag4", "Diagnosis D")
    .setControlName("Diag4")
    .createFormControl("", []);

  diag5Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag5", "Diagnosis E")
    .setControlName("Diag5")
    .createFormControl("", []);

  diag6Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag6", "Diagnosis F")
    .setControlName("Diag6")
    .createFormControl("", []);

  diag7Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag7", "Diagnosis G")
    .setControlName("Diag7")
    .createFormControl("", []);

  diag8Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag8", "Diagnosis H")
    .setControlName("Diag8")
    .createFormControl("", []);

  allDiagnoses: diagnosis[] = [];
  searchSelectedDiags: any[] = []
  allNotes: encounterprogressnotes[] = [];
  allAttachments: externaldata[] = [];
  allEncounters: encounter[] = [];
  assignedEncounters: encounter[] = [];

  apply: IcecontrolSettings = new IcecontrolSettings("icecheckbox", { width: "100%", cursor: 'pointer', label: "Include" }, null, null, "ApplyToBill", "Test")
    .setControlName("ApplyToBill")
    .createFormControl(false, [Validators.required]);

  status: any = {};
  dateFrom: any = {};
  dateTo: any = {};
  itemDesc: any = {};
  note: any = {};
  quantity: any = {};
  unitAmount: any = {};
  totalAmount: any = {};
  amountDue: any = {};
  amountPaid: any = {};
  billTo: any = {};
  unitsInStock: any = {};
  inventoryItemInfo: any = {};
  diagPointers: any = {};
  modifiers: any = {};
  attachmentSelection: any = {};
  providersListCtrl: any = {};

  newAttachmentTitle: any = {};
  newAttachmentProvider: any = {};
  newAttachmentDocumentStatus: any = {};
  newAttachmentType: any = {};
  newAttachmentDate: any = {};
  submitNewAttachment: any = {};
  cancelNewAttachment: any = {};

  newAttachments: any = {};

  billingsummary: any = {};

  amountSummary: any = {};
  itemSummaryActivity: string = "100";
  itemSummaryModifiers: string = "101";
  itemSummaryDiagnosis: string = "102";
  itemSummaryTaxStatus: string = "103";
  itemSummaryAttachments: string = "104";
  itemSummaryProviders: string = "105";
  itemSummaryComments: string = "106";
  pointerOne: number = 0;
  pointerTwo: number = 1;
  pointerThree: number = 2;
  pointerFour: number = 3;
  pointerFive: number = 4;
  pointerSix: number = 5;
  pointerSeven: number = 6;
  pointerEight: number = 7;
  diagnosisLabels: string[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  deleteConfirmationDialogRef: any = null;
  billKey: string = "";
  loading: boolean = false;
  previousPage: string = "";
  navOptions: { fragment: string };

  addItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Add Item", glyphClass: "fa-plus-circle" }, null, null, "addItem");
  benefitsButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Benefits", glyphClass: "fa-file-alt" }, null, null, "gotoBenefits");

  submitNewItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Submit Item", glyphClass: "fa-plus-circle" }, null, null, "submitItem");

  continueButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Continue", glyphClass: "fa-file-alt" }, null, null, "continueButton");
  doneButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Done" }, null, null, "doneButton");
  backButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Back", glyphClass: "" }, null, null, "backButton");
  printButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Print" }, null, null, "printButton");
  claimsButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Claims" }, null, null, "printButton");

  // Payment:
  paymentCtrl = new IcecontrolSettings("icesubscriptionpayment", {
    menuItems: [],
    width: "475px",
    purchaseCaption: "Account Balance Summary",
    paymentMethods: [PaymentMethods.pmCash],
    subTotal: 0.0,
    otherFees: 0.0,
    grandTotal: 0.0,
    lastErrors: null,
    defaultCountry: "",
    defaultCurrency: ""
  }, null, null, "paymentstatus")
    .setControlName("paymentstatus")
    .createFormControl({}, [Validators.required]);

  constructor(private appSvc: AppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private ptSvc: PatientService,
    private proSvc: ProviderService,
    private acctSvc: AccountingService,
    private medCodeSvc: MedicalcodesService,
    private messageSvc: MessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public dialog: MatDialog) {

    this.appSvc.defaultMenus();
    this.addBreadcrumbs();

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.billToStatus.setOptions(MessageService.getAccountItemStatues());

    this.activatedRoute.fragment.subscribe(data => {
      if (Iceutility.isdefined(data)) {
        this.previousPage = data;

        if (data === AppConstants.LedgerPage) {
          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: "Ledger - Outstanding Balance",
            data: null,
            active: true,
            link: "",
            history: []
          });
        } else if (data === AppConstants.ServiceChargeHistoryPage) {
          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: "Service Charge History - Outstanding Balance",
            data: null,
            active: true,
            link: "",
            history: []
          });
        }

        this.navOptions = {
          fragment: this.previousPage === AppConstants.LedgerPage ? AppConstants.LedgerPage :
            (this.previousPage === AppConstants.ServiceChargeHistoryPage ? AppConstants.ServiceChargeHistoryPage : AppConstants.OutstandingBalancePage)
        }
      }
    });

    // To do Get Default Currency and Country
    this.activatedRoute.params.subscribe(next => {
      this.billKey = next.key;

      this.acctSvc.getBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), next.key).subscribe(
        data => {
          if (data == null || data.length == 0) return;

          this.serviceCharges = <superbillcharges>data[0];
          if (this.serviceCharges == null) return;

          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btYard.toString(), {
            display: this.serviceCharges.bill_to,
            data: null,
            active: true,
            /*link: (Iceutility.formatUrl(this.router) + `#${this.serviceCharges.to_trans_account}`),*/
            link: "",
            history: []
          });

          let headerCtrls = {};
          headerCtrls[this.billToStatus.getControlName()] = this.billToStatus.getFormControl();
          headerCtrls[this.diag1Ctrl.getControlName()] = this.diag1Ctrl.getFormControl();
          headerCtrls[this.diag2Ctrl.getControlName()] = this.diag2Ctrl.getFormControl();
          headerCtrls[this.diag3Ctrl.getControlName()] = this.diag3Ctrl.getFormControl();
          headerCtrls[this.diag4Ctrl.getControlName()] = this.diag4Ctrl.getFormControl();
          headerCtrls[this.diag5Ctrl.getControlName()] = this.diag5Ctrl.getFormControl();
          headerCtrls[this.diag6Ctrl.getControlName()] = this.diag6Ctrl.getFormControl();
          headerCtrls[this.diag7Ctrl.getControlName()] = this.diag7Ctrl.getFormControl();
          headerCtrls[this.diag8Ctrl.getControlName()] = this.diag8Ctrl.getFormControl();
          //
          this.billToStatus.getFormControl().setValue(Iceutility.toLong(this.serviceCharges.bill_status));
          this.outStandingBalanceFormGrp = new FormGroup(headerCtrls);

          let fromdt = "", todt = "";
          for (let ichrg = 0; ichrg < this.serviceCharges.CHARGES.length; ichrg++) {
            let chrgRef: medicalservicereference = <medicalservicereference>this.serviceCharges.CHARGES[ichrg];

            let foundMedSvc = data.filter(obj => obj.medical_service_key == chrgRef.medical_service_key);
            if (foundMedSvc.length == 0) continue;

            let svc: medicalservice = foundMedSvc[0];
            let fndSvcDts = svc.SVCDTS.filter(d => d.datetime_qualifier == "472");
            if (fndSvcDts.length > 0) {
              if (fromdt.length == 0)
                fromdt = fndSvcDts[0].date_required;

              if (todt.length == 0)
                todt = fndSvcDts[0].end_date_required;

              if (Iceutility.GetLocalDate(fromdt).getTime() > Iceutility.GetLocalDate(fndSvcDts[0].date_required).getTime())
                fromdt = fndSvcDts[0].date_required;

              if (Iceutility.GetLocalDate(todt).getTime() < Iceutility.GetLocalDate(fndSvcDts[0].end_date_required).getTime())
                todt = fndSvcDts[0].end_date_required;
            }

            this.addChargeToList(foundMedSvc[0]);
          }

          if (this.isPatient()) {
            this.ptSvc.getProblems(this.serviceCharges.to_trans_account).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                this.allDiagnoses = <diagnosis[]>data;
                let diagOptions = [];
                let pointers = [
                  { name: "", value: -1 },
                  { name: "Diagnosis A): Unassigned", value: this.pointerOne, code: "", key: "" },
                  { name: "Diagnosis B): Unassigned", value: this.pointerTwo, code: "", key: "" },
                  { name: "Diagnosis C): Unassigned", value: this.pointerThree, code: "", key: "" },
                  { name: "Diagnosis D): Unassigned", value: this.pointerFour, code: "", key: "" },
                  { name: "Diagnosis E): Unassigned", value: this.pointerFive, code: "", key: "" },
                  { name: "Diagnosis F): Unassigned", value: this.pointerSix, code: "", key: "" },
                  { name: "Diagnosis G): Unassigned", value: this.pointerSeven, code: "", key: "" },
                  { name: "Diagnosis H): Unassigned", value: this.pointerEight, code: "", key: "" },
                ];
                // change to use diag.key
                diagOptions.push({ value: "", name: "", code: "" });
                for (let idiag = 0; idiag < data.length; idiag++) {
                  let diag: diagnosis = <diagnosis>data[idiag];
                  if (diag.icd_code == "" || diag.icd_code.length == 0) continue;
                  let icdText = diag.icd_code + " - " + diag.title;

                  diagOptions.push({ value: diag.diagnosis_key, name: icdText, code: diag.icd_code });
                }
                this.diag1Ctrl.setOptions(diagOptions);
                this.diag2Ctrl.setOptions(diagOptions);
                this.diag3Ctrl.setOptions(diagOptions);
                this.diag4Ctrl.setOptions(diagOptions);
                this.diag5Ctrl.setOptions(diagOptions);
                this.diag6Ctrl.setOptions(diagOptions);
                this.diag7Ctrl.setOptions(diagOptions);
                this.diag8Ctrl.setOptions(diagOptions);
                this.searchSelectedDiags = this.searchSelectedDiags.concat(diagOptions);

                // change to use diag.key
                if (this.serviceCharges.DIAGS.length >= 1) {
                  let idx = this.pointerOne;
                  this.diag1Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 2) {
                  let idx = this.pointerTwo;
                  this.diag2Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 3) {
                  let idx = this.pointerThree;
                  this.diag3Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 4) {
                  let idx = this.pointerFour;
                  this.diag4Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 5) {
                  let idx = this.pointerFive;
                  this.diag5Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 6) {
                  let idx = this.pointerSix;
                  this.diag6Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 7) {
                  let idx = this.pointerSeven;
                  this.diag7Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }
                if (this.serviceCharges.DIAGS.length >= 8) {
                  let idx = this.pointerEight;
                  this.diag8Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].diagnosis_key);
                }

                for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                  let charge: medicalservice = <medicalservice>this.chargeList[ichrg];
                  this.setPointers(charge, true, true);
                }
              },
              error => {
                // To do
              });

            this.ptSvc.getNotesList(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
              "", "", "", "").subscribe(
                data => {
                  if (data == null || data.length == 0) return;
                  this.allNotes = <encounterprogressnotes[]>data;
                },
                error => {
                  // To do
                });

            let fromDate = Iceutility.GetDateText(Iceutility.addTime(Iceutility.GetLocalDate(fromdt), -10, 0, 0, 0), "-", false) + " 12:00:00 AM";
            let toDate = Iceutility.GetDateText(Iceutility.GetLocalDate()/*Iceutility.GetLocalDate(todt)*/, "-", false) + " 11:59:59 PM";
            this.ptSvc.getEncounters(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", ""/*fromDate*/, toDate, "").subscribe(
              data => {
                if (data == null || data.length == 0) return;
                for (let idat = 0; idat < data.length; idat++) {
                  if (Iceutility.isfunction(data[idat].gettablename) && data[idat].gettablename() == "ENCOUNTER") {
                    let enc = <encounter>data[idat];
                    this.allEncounters.push(enc);
                  }
                }
              },
              error => {
                // To do
              });

            for (let ienc = 0; ienc < this.serviceCharges.NOTES.length; ienc++) {
              let nteRef = this.serviceCharges.NOTES[ienc];
              if (nteRef.encounter_key.length > 0 && nteRef.encounter_progress_notes_key.length == 0) {
                this.ptSvc.getEncounter(this.appSvc.getCurrentAccount(), this.serviceCharges.to_trans_account, nteRef.encounter_key, this.appSvc.getCurrentAccountType()).subscribe(
                  encData => {
                    if (encData == null || encData.length == 0) return;
                    this.assignedEncounters.push(<encounter>encData[0]);

                    if (this.assignedEncounters.length > 0) {
                      console.log(this.assignedEncounters.length);
                      console.log(encData[0]);
                    }

                    this.medCodeSvc.getCodes("DATETIME_CODE", "", [encData[0].time_slot_start, encData[0].time_slot_end, encData[0].modified].join(","), "").subscribe(
                      dtdata => {
                        if (dtdata && dtdata.length > 0) {
                          for (let ibc = 0; ibc < dtdata.length; ibc++) {
                            let bc: basecode = dtdata[ibc];
                            let bcdate = Iceutility.GetLocalDate(bc.title).toLocaleString();
                            if (bc.code == encData[0].time_slot_start)
                              encData[0].time_slot_start = bcdate;
                            else if (bc.code == encData[0].time_slot_end)
                              encData[0].time_slot_end = bcdate;
                            else if (bc.code == encData[0].modified)
                              encData[0].modified = bcdate;
                          }
                        }
                      },
                      error => {
                        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
                      });

                  },
                  encErr => {
                  }
                );
              }
            }

            if (this.listOfPayerResponsibities.length == 0) {
              this.medCodeSvc.getCodes("PAYER_RESPONSIBILITY_SEQUENCE_NUMBER", "", "", "").subscribe(
                data => {
                  if (data && data.length > 0) {
                    this.listOfPayerResponsibities = <basecode[]>data;
                  }
                },
                error => {
                  // To do
                });
            }

            if (this.listOfModifiers.length == 0) {
              this.medCodeSvc.getCodes("MODIFIER_CODE", "", "", "").subscribe(
                data => {
                  if (data && data.length > 0) {
                    this.listOfModifiers = <basecode[]>data;

                    let options = [];
                    for (let imod = 0; imod < this.listOfModifiers.length; imod++) {
                      let bc = this.listOfModifiers[imod];
                      options.push({ value: bc.code, name: bc.code + " - " + bc.title });
                    }
                    options.sort(function (a, b) { return a.name.localeCompare(b.name) });

                    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                      let chrg: medicalservice = <medicalservice>this.chargeList[ichrg];
                      this.modifiers[chrg.medical_service_key].setOptions(options);

                      let mods = [];
                      let modSet = (m) => {
                        if (m != null && m.length > 0) { let t = m; let fndOpt = options.filter(o => o.value == m); if (fndOpt.length > 0) t = fndOpt[0].name; mods.push({ name: t, value: m }); }
                      };
                      modSet(chrg.modifier1);
                      modSet(chrg.modifier2);
                      modSet(chrg.modifier3);
                      modSet(chrg.modifier4);

                      let modCtrl: IcecontrolSettings = this.modifiers[chrg.medical_service_key];
                      modCtrl.getFormControl().setValue(JSON.stringify(mods));
                    }
                  }
                },
                error => {
                  console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
                });
            }
          }

          let api = null;
          if (this.isPatient()) api = "patients";
          else if (this.isSubscriber()) api = "subscribers";

          if (api != null) {
            this.domainSvc.getDocuments(api,
              this.serviceCharges.to_trans_account,
              appSvc.getCurrentAccountType()/*more params will be added here to only pull from patient's cur provider*/,
              IceTypes.SourceType.srcUndefined).subscribe(
                data => {
                  if (data && data.length > 0) {
                    this.allAttachments = <externaldata[]>data;

                    let docsOpts = [{ name: "<Select Existing Document>", value: "", time: 999999999999999999 }];
                    for (let i = 0; i < data.length; i++) {
                      let doc: externaldata = <externaldata>data[i];
                      if (doc == null) continue;

                      let docDt = Iceutility.GetLocalDate(doc.external_reference_date);

                      let desc = AccountingService.getSourceType(Iceutility.toLong(doc.src_type)) + " " + doc.title + " Document on "
                        + Iceutility.getDateTextEx(docDt, null, true);
                      docsOpts.push({
                        name: desc,
                        value: doc.external_data_key,
                        time: docDt.getTime()
                      });
                    }

                    docsOpts.sort((a, b) => {
                      let aV: number = a["time"];
                      let bV: number = b["time"];
                      return bV - aV;
                    });

                    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                      let chrg: medicalservice = <medicalservice>this.chargeList[ichrg];
                      this.attachmentSelection[chrg.medical_service_key].setOptions(docsOpts);
                    }
                  }
                },
                error => {
                });
          }

          switch (Iceutility.toLong(this.serviceCharges.from_account_type)) {
            case IceTypes.ACCOUNT_TYPE.actProvider:
            case IceTypes.ACCOUNT_TYPE.actFacility: {
              this.proSvc.getPracticeProviders(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "").subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    this.networkProviders = data;
                    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                      let chrg: medicalservice = <medicalservice>this.chargeList[ichrg];
                      this.loadProviderListControl(chrg);
                    }

                  }
                },
                error => {
                  console.log(JSON.stringify(error))
                  this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading practice providers.");
                });
              this.domainSvc.getProvider(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let pro: provider = data[0];
                    this.currencies = pro.CURRENCIES;
                    this.countries = pro.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPharmacy: {
              this.domainSvc.getPharmacy(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let phrm: pharmacy = data[0];
                    this.currencies = phrm.CURRENCIES;
                    this.countries = phrm.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actVendor: {
              this.domainSvc.getVendor(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let ven: vendor = data[0];
                    this.currencies = ven.CURRENCIES;
                    this.countries = ven.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPayer: {
              this.domainSvc.getPayer(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let pyr: payer = data[0];
                    this.currencies = pyr.CURRENCIES;
                    this.countries = pyr.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            default: {
              break;
            }
          }

          this.remainingBalance = this.totalDue;
          //  this.ctrlBillingDomainType.getFormControl().setValue(Iceutility.toLong(bill.to_account_type));
          //  this.ctrlBillingDomainType.setDisabled(true);

          //  // Set Bill to
          //  this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: bill.to_trans_account, name: bill.bill_to }]));

          //  // Only one should be in bill charges control
          //  let orddesc = Iceutility.isTextDateTime(bill.created) ? Iceutility.getDateTextEx(bill.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(bill.created))
          //    + " - " + bill.superbill_charges_key.substr(0, 10);
          //  this.ctrlBillingDomainOrderCtrl.setOptions([{ value: bill.superbill_charges_key, name: orddesc }]);
          //  let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
          //  frmOrder.setValue(bill.superbill_charges_key);

          //  // Disable order
          //  this.ctrlBillingDomainOrderCtrl.setDisabled(true);
          //  // Load services
          //  this.loadMedicalServices(data);
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        });
    });
  }

  addBreadcrumbs() {
    this.breadcrumbService.updateBreadcrumb(BreadcrumType.btTree.toString(), { display: "Accounting", data: null, active: false, link: "/accounting/summary", history: [] });
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  getThisYear(): number {
    return Iceutility.getYear();
  }

  setPointers(charge: medicalservice, updatePointers: boolean, updateOptions: boolean): void {
    if (charge == null) return;

    let ptrCtrl: IcecontrolSettings = this.diagPointers[charge.medical_service_key];

    if (updatePointers) {
      let dxs = [];
      let dxSet = (d: diagnosisreference, ptr: number) => {
        if (d != null && ptr >= 0 && ptr < this.pointerEight) {
          dxs.push({ name: this.diagnosisLabels[ptr] + "): " + d.icd_code, value: d.diagnosis_key, code: d.icd_code });
        }
      };

      let fndMREF = this.serviceCharges.CHARGES.filter(x => x.medical_service_key == charge.medical_service_key);
      if (fndMREF.length > 0) {
        let mref: medicalservicereference = fndMREF[0];

        for (let iDiagRefPtr = 0; iDiagRefPtr < mref.DIAGREFS.length; iDiagRefPtr++) {
          let diagRef = mref.DIAGREFS[iDiagRefPtr];
          let ptr = this.serviceCharges.DIAGS.findIndex(d => diagRef.diagnosis_key == d.diagnosis_key);
          if (diagRef.diagnosis_key.length > 0)
            dxSet(diagRef, ptr);
        }
      }

      ptrCtrl.getFormControl().setValue(JSON.stringify(dxs));
    }

    if (updateOptions) {
      let opts = [];
      for (let idiag = 0; idiag < this.serviceCharges.DIAGS.length; idiag++) {
        let diag = this.serviceCharges.DIAGS[idiag];
        if (diag.diagnosis_key.length > 0)
          opts.push({ name: this.diagnosisLabels[idiag] + "): " + diag.icd_code, value: diag.diagnosis_key, code: diag.icd_code });
      }
      ptrCtrl.setOptions(opts);
    }
  }

  showDeleteDiagPointerLink(chge: medicalservice, ctrl: IcecontrolSettings, ptrDiagRefToUse: number): boolean {
    return true;
  }

  addChargeToList(charge: medicalservice): void {
    if (charge == null) return;

    this.chargeList.push(charge);

    this.status[charge.medical_service_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Status" + charge.medical_service_key, "Status of Item")
      .setControlName("Status" + charge.medical_service_key)
      .createFormControl(Iceutility.toLong(charge.trans_status), [Validators.required])
      .setOptions(MessageService.getAccountItemStatues());

    let dtFrom = Iceutility.isTextDateTime(charge.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].date_required), null, false);
    let dtTo = Iceutility.isTextDateTime(charge.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].end_date_required), null, false);

    this.dateFrom[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, {}, "DateFrom" + charge.medical_service_key)
      .setControlName("DateFrom" + charge.medical_service_key)
      .createFormControl(dtFrom, []);

    this.dateTo[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, {}, "dateTo" + charge.medical_service_key)
      .setControlName("dateTo" + charge.medical_service_key)
      .createFormControl(dtTo, []);

    this.itemDesc[charge.medical_service_key] = new IcecontrolSettings("icetextarea", { width: "100%", height: "100px" }, null, null, "ItemDescription" + charge.medical_service_key, "Service Description")
      .setControlName("ItemDescription" + charge.medical_service_key)
      .createFormControl(charge.service_description, [Validators.required]);

    this.note[charge.medical_service_key] = new IcecontrolSettings("icetextarea", { width: "100%" }, null, null, "AdditionalNote" + charge.medical_service_key, "Note")
      .setControlName("AdditionalNote" + charge.medical_service_key)
      .createFormControl(charge.additional_note, []);

    this.quantity[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, null, "Quantity" + charge.medical_service_key, "Quantity")
      .setControlName("Quantity" + charge.medical_service_key)
      .createFormControl(charge.quantity, []);

    this.unitAmount[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, null, "UnitAmount" + charge.medical_service_key, "Unit Amount")
      .setControlName("UnitAmount" + charge.medical_service_key)
      .createFormControl(charge.price, []);

    this.totalAmount[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, null, "TotalAmount" + charge.medical_service_key, "Total Amount")
      .setControlName("TotalAmount" + charge.medical_service_key)
      .createFormControl(charge.total_amount, []);

    this.amountDue[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%", color: "red" }, null, null, "AmountDue" + charge.medical_service_key, "Amount Due")
      .setControlName("AmountDue" + charge.medical_service_key)
      .createFormControl(charge.total_amount/*set this to the total then update below*/, []);

    this.amountPaid[charge.medical_service_key] = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "AmountPaid" + charge.medical_service_key, "Amount to Pay")
      .setControlName("AmountPaid" + charge.medical_service_key)
      .createFormControl(0.0, []);

    let partyBuckey = AccountingService.getPartyBucketKey(charge);
    if (this.partyBuckets[partyBuckey] == null)
      this.partyBuckets[partyBuckey] = { name: "", shortname: "", amount_due: 0.0 };

    if (this.responsibleParties.length == 0) {
      let optForBillTo = this.serviceCharges.bill_to + " (" + DomainService.getDomainType(Iceutility.toLong(this.serviceCharges.to_account_type)) + ", Cash Pay)";
      this.responsibleParties = [{ name: optForBillTo, value: "", summary: [] }];
    }
    this.billTo[charge.medical_service_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillTo" + charge.medical_service_key, "Responsible Party")
      .setControlName("BillTo" + charge.medical_service_key)
      .createFormControl(partyBuckey, [])
      .setOptions(this.responsibleParties);

    this.billingsummary[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%", height: "100px" }, null, null, "BillingSummary", "Summary")
      .setControlName("BillingSummary" + charge.medical_service_key)
      .createFormControl("", []);

    let isPT = this.isPatient();

    let summaryItems = [{
      text: "Activity", value: this.itemSummaryActivity,
      onclick: (event) => {
        if (event.value != null) {
          this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
        }
      }
    }];

    if (isPT) {
      summaryItems.push({
        text: "Modifiers", value: this.itemSummaryModifiers,
        onclick: (event) => {
          if (event.value != null) {
            this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
          }
        }
      });

      summaryItems.push({
        text: "Diagnosis", value: this.itemSummaryDiagnosis,
        onclick: (event) => {
          if (event.value != null) {
            this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
          }
        }
      });
    }

    summaryItems.push({
      text: "Tax Status", value: this.itemSummaryTaxStatus,
      onclick: (event) => {
        if (event.value != null) {
          this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
        }
      }
    });

    summaryItems.push({
      text: "Attachments", value: this.itemSummaryAttachments,
      onclick: (event) => {
        if (event.value != null) {
          this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
        }
      }
    });

    if (isPT) {
      summaryItems.push({
        text: "Providers", value: this.itemSummaryProviders,
        onclick: (event) => {
          if (event.value != null) {
            this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
          }
        }
      });
    }

    summaryItems.push({
      text: "Comments", value: this.itemSummaryComments,
      onclick: (event) => {
        if (event.value != null) {
          this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
        }
      }
    });

    this.amountSummary[charge.medical_service_key] = new IcecontrolSettings("icebuttongroup", {
      activeButton: this.itemSummaryActivity,
      groupSettings: summaryItems
    }, null, null, "", "")
      .setControlName("AmountSummary" + charge.medical_service_key);

    this.diagPointers[charge.medical_service_key] = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "Pointers", "Pointers to Diagnosis")
      .setControlName("diagpointers" + charge.medical_service_key)
      .createFormControl("", [])
      .setMultipleSelection(true)
      .setOptions([]);

    let mods = [];
    let modSet = (m) => { if (m != null && m.length > 0) { mods.push({ name: m, value: m }); } };
    modSet(charge.modifier1);
    modSet(charge.modifier2);
    modSet(charge.modifier3);
    modSet(charge.modifier4);

    this.modifiers[charge.medical_service_key] = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "Modifiers", "Service Modifiers")
        .setControlName("modifiers_" + charge.medical_service_key)
        .createFormControl(JSON.stringify(mods), [])
        .setMultipleSelection(true)
        .setOptions([]);

    this.attachmentSelection[charge.medical_service_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "attachmentSelection_" + charge.medical_service_key, "Document Attachments")
      .setControlName("attachmentSelection_" + charge.medical_service_key)
      .createFormControl("", [])
      .setOptions([]);

    let editAction = {
      name: IceTypes.recordQuickActionEdit.name,
      value: IceTypes.recordQuickActionEdit.value,
      iconClass: { "fas": true, "fa-edit": true }
    };

    let deleteAction = {
      name: IceTypes.recordQuickActionRemove.name,
      value: IceTypes.recordQuickActionRemove.value,
      iconClass: { "fas": true, "fa-trash": true }
    };

    this.providersListCtrl[charge.medical_service_key]
      = new IcecontrolSettings(charge.medical_service_key, {}, null, null, "", "Providers")
        .setOptions([])
        .setActionItems([
          editAction,
          deleteAction
        ]);

    if (charge.unit_code != null && charge.unit_code.length > 0) {
      this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", charge.unit_code, "").subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            //chrgObj.unit_code = data[0].title;
          }
        },
        error => {
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });
    }

    if (this.isSupplies(charge)) {
      this.acctSvc.getOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), charge.other_items_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            this.inventoryItemInfo[charge.other_items_key] = data[0];
          }
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        });

      // To do: We should add charge.quantity_confirmed; // which means that its been removed from inventory
      // if confirmed then display "Inventory Confirmed"
      this.acctSvc.getItemReceiving(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), charge.other_items_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            let itemReceiving: otheritemsreceiving[] = data;
            if (this.unitsInStock[charge.other_items_key] == null)
              this.unitsInStock[charge.other_items_key] = 0.0;

            for (let i = 0; i < itemReceiving.length; i++) {
              this.unitsInStock[charge.other_items_key] += Iceutility.toDouble(itemReceiving[i].quantity);
            }
          }
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        }
      );

      this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtInventory, IceTypes.coa_types.coaInventory, "", IceTypes.coa_types.coaInventory).subscribe(
        data => {
          if (data != null) {
            if (this.unitsInStock[charge.other_items_key] == null)
              this.unitsInStock[charge.other_items_key] = 0.0;

            for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
              let jrnl: otheritemsjournal = data[ijrnl];
              let crd = Iceutility.toDouble(jrnl.credit);
              if (charge.other_items_key == jrnl.other_items_key && crd > 0) {
                this.unitsInStock[charge.other_items_key] -= Iceutility.toDouble(jrnl.quantity);
              }
            }
          }
        },
        error => {
          console.log(error);
        });
    }

    if (this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient) {
      if (this.responsibleParties.length <= 1) {
        this.ptSvc.getPatientSubscriberRefs(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
          data => {
            if (data != null) {
              this.patientSubRefs = data;
              this.ptSvc.getPatientSubscribers(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
                subdata => {
                  if (subdata != null && this.responsibleParties.length <= 1) {
                    this.patientSubscribers = subdata;
                    let ctrl: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
                    for (let isub = 0; isub < subdata.length; isub++) {
                      let sub: subscriber = subdata[isub];
                      if (sub.COVGS.length > 0) {
                        if (this.pyrCovs == null || this.pyrCovs.length == 0)
                          this.pyrCovs = this.ptSvc.getPayerCoverageBenefits(sub, true, this.patientSubRefs, this.listOfPayerResponsibities);

                        if (this.pyrCovs != null) {
                          for (let icov = 0; icov < this.pyrCovs.length; icov++) {
                            let covDtl = this.pyrCovs[icov];
                            this.responsibleParties.push({
                              name: covDtl["payer_name"],
                              value: covDtl["payer_id"],
                              summary: covDtl.summary
                            });
                          }
                        }
                      }
                    }
                    ctrl.setOptions(this.responsibleParties);
                  }
                },
                error => {
                  console.log(error);
                });
            }
          },
          err => {

          });
      }
      else {
        let ctrl: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
        ctrl.setOptions(this.responsibleParties);
      }
    }

    this.currentChargeHistory.setService(charge.medical_service_key, {});
    this.currentChargeHistory.setServiceAmountDue(charge.medical_service_key, Iceutility.toDouble(charge.total_amount));
    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, charge.medical_service_key, IceTypes.coa_types.coaDeductibleAR).subscribe(
      data => {
        let partyBucketKey = AccountingService.getPartyBucketKey(charge);

        if (data != null) {
          let credits = AccountingService.updateChargeHistoryPostingData(this.acctSvc, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
            this.currentChargeHistory, charge, data);
          let ctrl: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
          let frmCtrl = ctrl.getFormControl();
          frmCtrl.setValue(frmCtrl.value - credits);
          ctrl.properties.color = frmCtrl.value > 0 ? "red" : "green";

          this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrl.value);
          this.totalDue += Iceutility.toDouble(frmCtrl.value);
          this.currentChargeHistory.setServiceAmountDue(charge.medical_service_key, Iceutility.toDouble(frmCtrl.value));
        }
        else {
          this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(charge.total_amount);
          this.totalDue += Iceutility.toDouble(charge.total_amount);
        }

        if (Iceutility.toDouble(charge.total_amount) === this.totalDue) {
          charge["_canDelete"] = true;
        }
      },
      error => {
        console.log(error);
      });

    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtExpense, IceTypes.coa_types.coaDiscount, charge.medical_service_key, IceTypes.coa_types.coaCorrectionandReversalsAdjustment).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceExpenses(charge.medical_service_key, data);
        }
      },
      error => {
        console.log(error);
      });

    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtIncome, IceTypes.coa_types.coaRevenue, charge.medical_service_key, IceTypes.coa_types.coaCoInsuranceIncome).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceIncomes(charge.medical_service_key, data);
        }
      },
      error => {
        console.log(error);
      });

    this.acctSvc.getClaims(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges.to_trans_account, this.serviceCharges.to_account_type, "", "", "", "", -1, charge.medical_service_key).subscribe(
      data => {
        if (data == null || data.length == 0) {
          return;
        }
        this.currentChargeHistory.setClaims(charge.medical_service_key, data);
      }, error => {
        console.log(JSON.stringify(this.acctSvc.getLastErrors()));
      });

    for (let imsg = 0; imsg < charge.MSGS.length; imsg++) {
      let msgref = charge.MSGS[imsg];
      this.messageSvc.getMessage(msgref.message_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            let msg: message = data[0];
            if (msg == null) return;
            this.listOfMessages.push(msg);
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  getOutStandingBalanceHeaderGroup(): FormGroup {
    return this.outStandingBalanceFormGrp;
  }

  isPatient(): boolean {
    return this.serviceCharges != null && this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient;
  }

  isSubscriber(): boolean {
    return this.serviceCharges != null && this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actSubscriber;
  }

  getPatientAccount(): string {
    if (this.serviceCharges != null && this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient)
      return this.serviceCharges.to_trans_account;

    return "";
  }

  isSupplies(charge: medicalservice): boolean {
    return charge != null && Iceutility.toBoolean(charge.service_option) == false;
  }

  getServiceOptionText(charge: medicalservice): string {
    if (charge == null) return "";

    let ret = "Service";
    if (charge.inc_coa_type == IceTypes.coa_types.coaOtherIncome) {
      ret = !this.isSupplies(charge) ? "Service" : "Supplies";
    }
    else if (charge.inc_coa_type == IceTypes.coa_types.coaCoPayIncome) {
      ret = "Co-Payment"
    }

    return ret;
  }

  getAmountToBill(charge: medicalservice): string {
    if (charge == null) return "";

    let ret = "0.0";
    let ctrlAmtDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
    let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[charge.medical_service_key];
    let frmCtrlDue = ctrlAmtDue.getFormControl();
    let frmCtrlPaid = ctrlPaid.getFormControl();
    if (frmCtrlPaid && frmCtrlDue) {
      let amtDue = frmCtrlDue.value;
      let amtPaid = frmCtrlPaid.value;
      ret = (Iceutility.toDouble(amtDue) - Iceutility.toDouble(amtPaid)).toString();
    }
    return ret;
  }

  getPayHistory(charge: medicalservice, newPostOnly: boolean = false): string {
    let ret = "0.0";
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      let total = 0.0;
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        if (newPostOnly && thispost.offline_record_status != IceTypes.offlineRecStatus.offlineInsert) {
          continue;
        }
      
        for (let isvc = 0; isvc < thispost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = thispost.SERVICES[isvc];
          if (svcref != null && 
            (IceTypes.coa_types.coaAR == svcref.coa_type
            || IceTypes.coa_types.coaCoInsuranceAR == svcref.coa_type
            || IceTypes.coa_types.coaDeductibleAR == svcref.coa_type)) {
            total += Iceutility.toDouble(svcref.amount);
          }
        }
      }
      ret = Iceutility.toDouble(total).toString();
    }
    return ret;
  }

  getAdjustmentHistory(charge: medicalservice): string {
    let ret = "0.0";
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      let total = 0.0;
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        for (let isvc = 0; isvc < thispost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = thispost.SERVICES[isvc];
          if (svcref != null &&
            (IceTypes.coa_types.coaClaimAdjustment == svcref.coa_type
            || IceTypes.coa_types.coaDisallowedAdjustment == svcref.coa_type
            || IceTypes.coa_types.coaContractualObligationsAdjustment == svcref.coa_type
            || IceTypes.coa_types.coaCorrectionandReversalsAdjustment == svcref.coa_type)) {
            total += Iceutility.toDouble(svcref.amount);
          }
        }
      }
      ret = Iceutility.toDouble(total).toString();
    }
    return ret;
  }

  getDiscountHistory(charge: medicalservice): string {
    let ret = "0.0";
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      let total = 0.0;
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        for (let isvc = 0; isvc < thispost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = thispost.SERVICES[isvc];
          if (svcref != null &&
            (IceTypes.coa_types.coaDiscount == svcref.coa_type)) {
            total += Iceutility.toDouble(svcref.amount);
          }
        }
      }
      ret = Iceutility.toDouble(total).toString();
    }
    return ret;
  }

  getNewPostings(charge: medicalservice): payment[] {
    let ret: payment[] = null;
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        if (thispost.offline_record_status != IceTypes.offlineRecStatus.offlineInsert) {
          continue;
        }
        if (ret == null)
          ret = [];

        ret.push(thispost);
      }
    }
    return ret;
  }

  getItemSummaryActiveButton(charge: medicalservice): string {
    if (charge == null || this.amountSummary[charge.medical_service_key] == null
      || this.amountSummary[charge.medical_service_key].properties == null) return "";

    return this.amountSummary[charge.medical_service_key].properties.activeButton;
  }

  getTotalTax(): string {
    return this.totalTax.toString();
  }

  getTotalDue(): string {
    return this.totalDue.toString();
  }

  getTotalPaidAmount(): string {
    if (this.payPost == null) return "0";
    return this.payPost.total_paid.toString();
  }

  getRemainingBalance(): string {
    let ret = 0.0;
    let paid = 0.0;
    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let chrg = this.chargeList[ichrg];
      let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[chrg.medical_service_key];
      let frmCtrlPaid = ctrlPaid.getFormControl();
      if (frmCtrlPaid) {
        paid += Iceutility.toDouble(frmCtrlPaid.value);
      }
    }
    if (this.payPost != null) this.payPost.total_paid = paid;
    this.remainingBalance = this.totalDue - paid;
    return this.remainingBalance.toString();
  }

  getPartyBuckets(): any[] {
    let ret = Object.keys(this.partyBuckets).map((key) => {
      if (this.partyBuckets[key].name == null || this.partyBuckets[key].name.length == 0) {
        if (this.pyrCovs != null && this.pyrCovs.length > 0) {
          let covFound = this.pyrCovs.filter(c => c.payer_id == key);
          if (covFound.length > 0) {
            this.partyBuckets[key].name = covFound[0].payer_name;            
          }
          else if (key == null || key.length == 0) {
            this.partyBuckets[key].name = this.serviceCharges.bill_to;
          }

          this.partyBuckets[key].shortname = AccountingService.getResponsiblePartyShortName(this.partyBuckets[key].name);
        }
      }
      return {
        partykey: key,
        name: this.partyBuckets[key].name,
        shortname: this.partyBuckets[key].shortname,
        amount_due: this.partyBuckets[key].amount_due
      }
    });
    return ret;
  }

  getCurrency(): string {
    return this.currencies.length > 0 ? this.currencies[0].code : "USD";
  }

  getEditServiceClass(chge: medicalservice): any {
    return { "fas": true, "fa-edit": true, "fa-2x": true };
  }

  getDeleteServiceClass(): any {
    return { "fas": true, "fa-trash": true, "fa-2x": true };
  }

  getAttachmentDate(extData: externaldata): string {
    if (extData == null) return "";
    return Iceutility.getDateTextEx(
      Iceutility.isTextDateTime(extData.external_reference_date) ? extData.external_reference_date : Iceutility.ConvertFromDotNetServerTime(extData.external_reference_date));
  }

    // Saved Attachments
  getAttachments(charge: medicalservice): externaldata[] {
    
    let ret: externaldata[] = [];
    for (let ieRef = 0; ieRef < charge.EDOCS.length; ieRef++) {
      let extDataRef = charge.EDOCS[ieRef];
      if (Iceutility.toLong(extDataRef.offline_record_status) != IceTypes.offlineRecStatus.offlineDelete) {
        let foundAttachment = this.allAttachments.filter(x => x.external_data_key == extDataRef.external_data_key);
        if (foundAttachment.length > 0) {
          ret.push(foundAttachment[0]);
        }
      }
    }
    return ret;
  }

  //getAttachment
  /*
  eobj.external_reference_date = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(eobj.external_reference_date));
  eobj.external_reference_end_date = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(eobj.external_reference_end_date));
  let foundType = this.docTypeCtrl.getOptions().filter(t => t.value == eobj.sub_type);
  if (foundType.length > 0)
    eobj.sub_type = foundType[0].name;

  let foundStatus = DomainService.getNoteStatuses().filter(s => s.value == eobj.note_status_type);
  if (foundStatus.length > 0)
    eobj.note_status_type = foundStatus[0].name;

  eobj.modified = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(eobj.modified));
  */

  // New Attachments
  getNewAttachments(chge: medicalservice): externaldata[] {
    if (this.newAttachments[chge.medical_service_key] == null)
      this.newAttachments[chge.medical_service_key] = [];

    let ret: externaldata[] = [];
    let newAttachments: externaldata[] = <externaldata[]>this.newAttachments[chge.medical_service_key];    
    for (let ifile = 0; ifile < newAttachments.length; ifile++) {
      let extData = newAttachments[ifile];
      if (extData.offline_record_status != IceTypes.offlineRecStatus.offlineDelete) {
        ret.push(extData);
      }
    }

    return ret;
  }

  getNewAttachmentUrl(extData: externaldata): string {
    return DefaultPostingImage;
  }

  getNewAttachmentType(chge: medicalservice, extData: externaldata): string {
    let found = chge.EDOCS.filter(x => x.external_data_key == extData.external_data_key);
    if (found.length > 0) {
      let extDataRef = found[0];
      if (extDataRef["tempFile"] == null) return "";
      return extDataRef["tempFile"]["type"];
    }
    return "";
  }

  getNewAttachmentSize(chge: medicalservice, extData: externaldata): string {
    let found = chge.EDOCS.filter(x => x.external_data_key == extData.external_data_key);
    if (found.length > 0) {
      let extDataRef = found[0];
      if (extDataRef["tempFile"] == null) return "";
      return extDataRef["tempFile"]["size"];
    }
    return "";
  }

  getNewAttachmentStatus(chge: medicalservice, extData: externaldata): string {
    return "Copying";
  }

  getNewAttachmentTitleControl(chge: medicalservice, extData: externaldata): IcecontrolSettings {
    if (chge == null || extData == null) return null;

    if (this.newAttachmentTitle[chge.medical_service_key] == null)
      this.newAttachmentTitle[chge.medical_service_key] = {};

    if (this.newAttachmentTitle[chge.medical_service_key][extData.external_data_key] == null)
      this.newAttachmentTitle[chge.medical_service_key][extData.external_data_key] = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "svcAttchTitle_" + chge.medical_service_key + "_" + extData.external_data_key, "Title of Attachment")
        .setControlName("svcAttchTitle_" + chge.medical_service_key + "_" + extData.external_data_key)
        .createFormControl("", []);

    return this.newAttachmentTitle[chge.medical_service_key][extData.external_data_key];
  }

  getNewAttachmentDateControl(chge: medicalservice, extData: externaldata): IcecontrolSettings {
    if (chge == null || extData == null) return null;

    if (this.newAttachmentDate[chge.medical_service_key] == null)
      this.newAttachmentDate[chge.medical_service_key] = {};

    if (this.newAttachmentDate[chge.medical_service_key][extData.external_data_key] == null)
      this.newAttachmentDate[chge.medical_service_key][extData.external_data_key] = new IcecontrolSettings("icedatepicker", { width: "100%" }, null, null, "svcAttchDate_" + chge.medical_service_key + "_" + extData.external_data_key, "Date of Attachment")
        .setControlName("svcAttchDate_" + chge.medical_service_key + "_" + extData.external_data_key)
        .createFormControl(Iceutility.GetLocalDate(), []);

    return this.newAttachmentDate[chge.medical_service_key][extData.external_data_key];
  }

  getNewAttachmentProviderControl(chge: medicalservice, extData: externaldata): IcecontrolSettings {
    if (chge == null || extData == null) return null;

    if (this.newAttachmentProvider[chge.medical_service_key] == null)
      this.newAttachmentProvider[chge.medical_service_key] = {};

    if (this.newAttachmentProvider[chge.medical_service_key][extData.external_data_key] == null) {
      let opts = [];
      for (let ipro = 0; ipro < this.networkProviders.length; ipro++) {
        let proIdx: provider_index = this.networkProviders[ipro];
        opts.push({ name: proIdx.getdisplayname(false), value: proIdx.trans_account });
      }

      this.newAttachmentProvider[chge.medical_service_key][extData.external_data_key] = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "300px" }, null, null, "svcAttchProvider_" + chge.medical_service_key + "_" + extData.external_data_key, "Author of Note")
        .setControlName("svcAttchProvider_" + chge.medical_service_key + "_" + extData.external_data_key)
        .createFormControl("", [])
        .setOptions(opts);
    }

    return this.newAttachmentProvider[chge.medical_service_key][extData.external_data_key];
  }

  getNewAttachmentDocumentStatusControl(chge: medicalservice, extData: externaldata): IcecontrolSettings {
    if (chge == null || extData == null) return null;

    if (this.newAttachmentDocumentStatus[chge.medical_service_key] == null)
      this.newAttachmentDocumentStatus[chge.medical_service_key] = {};

    if (this.newAttachmentDocumentStatus[chge.medical_service_key][extData.external_data_key] == null)
      this.newAttachmentDocumentStatus[chge.medical_service_key][extData.external_data_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "300px" }, null, null, "svcAttchStatus_" + chge.medical_service_key + "_" + extData.external_data_key, "Status")
        .setControlName("svcAttchStatus_" + chge.medical_service_key + "_" + extData.external_data_key)
        .createFormControl(Iceutility.toLong(extData.note_status_type), [])
        .setOptions(DomainService.getNoteStatuses())

    return this.newAttachmentDocumentStatus[chge.medical_service_key][extData.external_data_key];
  }

  getNewAttachmentTypeControl(chge: medicalservice, extData: externaldata): IcecontrolSettings {
    if (chge == null || extData == null) return null;

    if (this.newAttachmentType[chge.medical_service_key] == null)
      this.newAttachmentType[chge.medical_service_key] = {};

    if (this.newAttachmentType[chge.medical_service_key][extData.external_data_key] == null)
      this.newAttachmentType[chge.medical_service_key][extData.external_data_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "300px" }, null, null, "svcAttchType_" + chge.medical_service_key + "_" + extData.external_data_key, "Status")
        .setControlName("svcAttchType_" + chge.medical_service_key + "_" + extData.external_data_key)
        .createFormControl(Iceutility.toLong(extData.src_type), [])
        .setOptions([
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcCCD), value: IceTypes.SourceType.srcCCD },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcClinicalResults), value: IceTypes.SourceType.srcClinicalResults },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcEncounterNotes), value: IceTypes.SourceType.srcEncounterNotes },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcExam), value: IceTypes.SourceType.srcExam },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcFamilyConference), value: IceTypes.SourceType.srcFamilyConference },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcImage), value: IceTypes.SourceType.srcImage },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcImmunization), value: IceTypes.SourceType.srcImmunization },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcMiscellaneousForms), value: IceTypes.SourceType.srcMiscellaneousForms },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcOther), value: IceTypes.SourceType.srcOther },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcPatientDemographics), value: IceTypes.SourceType.srcPatientDemographics },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcPayment), value: IceTypes.SourceType.srcPayment },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcProcedure), value: IceTypes.SourceType.srcProcedure },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcReferral), value: IceTypes.SourceType.srcReferral },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcTestProcedure), value: IceTypes.SourceType.srcTestProcedure },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcTreatmentPlan), value: IceTypes.SourceType.srcTreatmentPlan },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcVitals), value: IceTypes.SourceType.srcVitals },
          { name: AccountingService.getSourceType(IceTypes.SourceType.srcXRayRad), value: IceTypes.SourceType.srcXRayRad },
        ])

    return this.newAttachmentType[chge.medical_service_key][extData.external_data_key];
  }

  showNewAttachmentButtons(chge: medicalservice): boolean {
    let show = false;
    let newAttachments: externaldata[] = <externaldata[]>this.newAttachments[chge.medical_service_key];
    for (let ifile = 0; ifile < newAttachments.length; ifile++) {
      let extData = newAttachments[ifile];
      if (extData != null && extData.offline_record_status != IceTypes.offlineRecStatus.offlineDelete) {
        show = true;
      }
    }

    return show;
  }

  getComments(chge: medicalservice): message[] {
    let ret = [];

    for (let imsg = 0; imsg < chge.MSGS.length; imsg++) {
      let msgref = chge.MSGS[imsg];
      let fndMsg = this.listOfMessages.filter(m => m.message_key == msgref.message_key);
      if (fndMsg.length > 0) {
        ret.push(fndMsg[0]);
      }
    }
    ret.sort((a, b) => {
      let aV = Iceutility.isTextDateTime(a.message_date) ? Iceutility.GetLocalDate(a.message_date) : Iceutility.ConvertFromDotNetServerTime(a.message_date);
      let bV = Iceutility.isTextDateTime(b.message_date) ? Iceutility.GetLocalDate(b.message_date) : Iceutility.ConvertFromDotNetServerTime(b.message_date);
      return bV.getTime() - aV.getTime();
    });
    return ret;
  }

  getCommentFrom(comment: message): string {
    let ret = comment.from;
    return ret;
  }

  getCommentDate(comment: message): string {
    let ret = Iceutility.isTextDateTime(comment.message_date) ? Iceutility.getDateTextEx(comment.message_date, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(comment.message_date), null, false);
    return ret;
  }

  getCommentSubject(comment: message): string {
    let ret = comment.subject;
    return ret;
  }

  getCommentBody(comment: message): string {
    let ret = comment.message_body;
    return ret;
  }

  showEditCommentLink(comment: message): boolean {
    return true;
  }

  showDeleteCommentLink(comment: message): boolean {
    let usrInfo = this.loginSvc.GetSessionUserInfo();
    if (usrInfo == null) return false;
    let userName: string = usrInfo.Username;
    return comment.from.toLocaleLowerCase() == userName.toLocaleLowerCase();
  }

  processMessage(result: any, chge: medicalservice): boolean {
    if (result == null || result.dialogRef == null) return false;

    let ref = result.dialogRef;
    if (result.dialogRef.componentInstance == null) return;
    let pnlData: IcepanelDialogData = <IcepanelDialogData>ref.componentInstance.data;
    if (pnlData == null) return;

    let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>pnlData.headerCtrl;
    if (hdrCtrl == null || hdrCtrl.id == "Close") return;

    let mref: messagereference = <messagereference>pnlData.record;
    let msg: message = <message>pnlData.parentrecord;
    let panel: IcepanelSettings = <IcepanelSettings>pnlData.panel;
    if (panel != null && msg != null && mref != null) {
      let form = panel.getForm();
      if (form != null && form.valid) {
        // flag dirty
        chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        for (let isec = 0; isec < panel.sections.length; isec++) {
          let sec = panel.sections[isec];
          for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
            let ctrl = sec.controls[ictrl];
            switch (ctrl.getControlName()) {
              case "to": {
                try {
                  let selectedRecips = JSON.parse(ctrl.getFormControl().value);
                  if (selectedRecips != null && selectedRecips.length > 0) {
                    msg.to = "";
                    for (let i = 0; i < selectedRecips.length; i++) {
                      if (msg.to.length > 0) msg.to += ",";
                      msg.to += selectedRecips[i].value;
                    }
                  }
                  else {
                    msg.to = msg.from;
                  }
                }
                catch (e) {
                  msg.to = msg.from;
                  console.log(e);
                }
                break;
              }
              case "subject": {
                msg.subject = ctrl.getFormControl().value;
                break;
              }
              case "message_body": {
                msg.message_body = ctrl.getFormControl().value;
                break;
              }
            }
          }
        }
      }
    }
    return true;
  }

  servicesModified(charges: medicalservice[]): boolean {
    if (charges == null) return false;

    return charges.filter(svc => Iceutility.toLong(svc.offline_record_status) != IceTypes.offlineRecStatus.offlineNoChange).length > 0;
  }

  bucketModified(): boolean {
    return Iceutility.toLong(this.serviceCharges.offline_record_status) != IceTypes.offlineRecStatus.offlineNoChange;
  }

  autoSaveBucket(): void {
    if (this.bucketModified()) {
      this.acctSvc.updateBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let bucket: superbillcharges = data[0];
            this.serviceCharges.offline_record_status = Iceutility.toLong(bucket.offline_record_status);
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  autoSaveServices(charges: medicalservice[]): void {
    if (charges == null || charges.length == 0) return;

    if (this.servicesModified(charges)) {
      // Update services again
      this.acctSvc.updateServices(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), charges).subscribe(
        data => {
          if (data != null) {
            for (let isvc = 0; isvc < charges.length; isvc++) {
              let charge = charges[isvc];
              charge.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;

              // loop here and reset docs to none
              for (let idoc = 0; idoc < charge.EDOCS.length; idoc++) {
                let extref = charge.EDOCS[idoc];
                if (extref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert
                  || extref.offline_record_status == IceTypes.offlineRecStatus.offlineUpdate) {
                  extref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                }
              }

              let fndRemoveDocDel = charge.EDOCS.filter(e => Iceutility.toLong(e.offline_record_status) != IceTypes.offlineRecStatus.offlineDelete);
              charge.EDOCS = fndRemoveDocDel;

              // loop here and reset messages to none
              for (let imsg = 0; imsg < charge.MSGS.length; imsg++) {
                let msgref = charge.MSGS[imsg];
                if (msgref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert
                  || msgref.offline_record_status == IceTypes.offlineRecStatus.offlineUpdate) {
                  msgref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                }
              }

              let fndRemoveMsgDel = charge.MSGS.filter(r => Iceutility.toLong(r.offline_record_status) != IceTypes.offlineRecStatus.offlineDelete);
              charge.MSGS = fndRemoveMsgDel;

              // loop here and reset providers to none
              for (let ipro = 0; ipro < charge.PROS.length; ipro++) {
                let proref = charge.PROS[ipro];
                if (proref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert
                  || proref.offline_record_status == IceTypes.offlineRecStatus.offlineUpdate) {
                  proref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                }
              }


              let fndRemoveProDel = charge.PROS.filter(r => Iceutility.toLong(r.offline_record_status) != IceTypes.offlineRecStatus.offlineDelete);
              charge.PROS = fndRemoveProDel;
            }
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  loadProviderListControl(chge: medicalservice): void {
    if (this.providersListCtrl[chge.medical_service_key] == null) return;

    let opts = [];
    let buildProvders: Function = (ctrl: IcecontrolSettings) => {
      for (let ipro = 0; ipro < chge.PROS.length; ipro++) {
        let proref = chge.PROS[ipro];

        let fndPro = this.networkProviders.filter(p => p.trans_account == proref.trans_account);
        if (fndPro.length > 0) {
          let dispName = fndPro[0].getdisplayname(false);
          let fndProCode = this.proSvc.providerCodeOrEntityOptions.filter(c => c.value == proref.provider_code);
          if (fndProCode.length > 0) {
            dispName += " (" + fndProCode[0].name + ")";
          }
          opts.push({ name: dispName, value: fndPro[0].trans_account });
        }
      }
      ctrl.setOptions(opts);
    };

    let ctrl: IcecontrolSettings = this.providersListCtrl[chge.medical_service_key];
    buildProvders(ctrl);
  }

  getProviderListControl(chge: medicalservice): IcecontrolSettings {
    return this.providersListCtrl[chge.medical_service_key];
  }

  setProviderListControlOption(chge: medicalservice, proref: provider_reference): boolean {
    if (this.providersListCtrl[chge.medical_service_key] == null) {
      return false;
    }

    let ctrl: IcecontrolSettings = this.providersListCtrl[chge.medical_service_key];
    if (ctrl == null) return false;

    let fndOpt = ctrl.getOptions().filter(o => o.value == proref.trans_account);
    if (fndOpt.length > 0) {
      let fndPro = this.networkProviders.filter(p => p.trans_account == proref.trans_account);
      if (fndPro.length > 0) {
        let dispName = fndPro[0].getdisplayname(false);
        let fndProCode = this.proSvc.providerCodeOrEntityOptions.filter(c => c.value == proref.provider_code);
        if (fndProCode.length > 0) {
          dispName += " (" + fndProCode[0].name + ")";
        }
        fndOpt[0].name = dispName;
        return true;
      }
    }
    return false;
  }

  calculatePaymentTotal(pmtCtrl: IcecontrolSettings): void {
    if (pmtCtrl == null) return;

    pmtCtrl.properties.subTotal = 0.0;
    pmtCtrl.properties.otherFees = 0.0;
    pmtCtrl.properties.grandTotal = 0.0;
    pmtCtrl.properties.lastErrors = null;

    let opts: licenseobject[] = pmtCtrl.getOptions();
    for (let iLic = 0; iLic < opts.length; iLic++) {
      let licObj: licenseobject = opts[iLic];
      if (licObj == null) continue;

      // lic condition
      if (licObj.license_id == 1) {
        // filter out licObj.COUNTRIES
        pmtCtrl.properties.subTotal += Iceutility.toDouble(licObj.rate);
      }
    }

    // Set Total
    pmtCtrl.properties.grandTotal = Iceutility.toDouble(pmtCtrl.properties.otherFees) + pmtCtrl.properties.subTotal;
  }

  initializePartyBuckets(defPartyBucket: string, ctrl: IcecontrolSettings): void {
    let testinitial = Object.keys(this.partyBuckets).map((key) => {
      this.partyBuckets[key].amount_due = 0.0;
      return this.partyBuckets[key];
    });

    if (ctrl == null) return;

    if (defPartyBucket != null) {
      let optFound = ctrl.getOptions().filter(o => o.value == defPartyBucket);
      if (this.partyBuckets[defPartyBucket] == null) {
        if (optFound.length > 0)
          this.partyBuckets[defPartyBucket] = { name: "", shortname: "", amount_due: 0.0 };
      }

      let summaryCtrl: IcecontrolSettings = <IcecontrolSettings>this.billingsummary[ctrl.id.replace("BillTo", "")];
      if (summaryCtrl != null) {
        summaryCtrl.getFormControl().setValue("");
        if (optFound.length > 0) {
          summaryCtrl.getFormControl().setValue(optFound[0].summary.join("<br>"));
        }
      }
    }
  }

  goToBucket(event) {
    this.router.navigate([this.navSvc.buildRoute("accounting/serviceitemcharge/" + this.serviceCharges.superbill_charges_key, false)], this.navOptions);
  }

  goToClaim(event) {
    this.router.navigate([this.navSvc.buildRoute("accounting/claimsbucket/" + this.serviceCharges.superbill_charges_key, false)], this.navOptions);
  }

  billToStatusChange(event): void {
    this.serviceCharges.bill_status = this.billToStatus.getFormControl().value;
    this.serviceCharges.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    this.autoSaveBucket();
  }

  attachmentSelectChange(event, chge: medicalservice) {
    if (chge == null) return;

    let foundAttachment = this.allAttachments.filter(x => x.external_data_key == event.value);
    if (foundAttachment.length > 0) {
      let extData: externaldata = foundAttachment[0];

      let extDataRef: externaldatareference = new externaldatareference();
      extDataRef.external_data_reference_key = Iceutility.guid(true);
      extDataRef.external_data_key = extData.external_data_key;
      extDataRef.parent_src_type = extData.parent_src_type;
      extDataRef.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
      chge.EDOCS.push(extDataRef);
      chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
      this.autoSaveServices([chge]);

      let selCtrl: IcecontrolSettings = <IcecontrolSettings>this.attachmentSelection[chge.medical_service_key];
      if (selCtrl != null) selCtrl.getFormControl().setValue("");
    }
  }

  addRemoveAttachmentClick(event, chge: medicalservice, extData: externaldata) {
    if (chge == null || extData == null) return;
    if (Iceutility.yesnomodal("Would you like to remove this attachment?")) {
      let fndExtRef = chge.EDOCS.filter(x => x.external_data_key == extData.external_data_key);
      if (fndExtRef.length > 0) {
        fndExtRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
      }
      chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
      extData.offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
      this.autoSaveServices([chge]);
    }
  }
  downloadAttachment(event, chge: medicalservice, extData: externaldata) {
    let api = null;
    if (this.isPatient()) api = "patients";
    else if (this.isSubscriber()) api = "subscribers";

    this.domainSvc.downloadDocument(api, chge.trans_account, extData.external_data_key, <IceTypes.SourceType>Iceutility.toLong(extData.parent_src_type));
  }

  submitNewAttachmentsClick(event: any, chge: medicalservice) {
    var attachments: externaldata[] = <externaldata[]>this.newAttachments[chge.medical_service_key];
    if (attachments.length == 0) return;

    let api = null;
    if (this.isPatient()) api = "patients";
    else if (this.isSubscriber()) api = "subscribers";
    if (api != null) {
      for (let ifile = 0; ifile < attachments.length; ifile++) {
        let thisAttachment = attachments[ifile];
        if (thisAttachment.offline_record_status == IceTypes.offlineRecStatus.offlineDelete) continue; // this attachment is already processed
        let fndExtRef = chge.EDOCS.filter(x => x.external_data_key == thisAttachment.external_data_key);
        if (fndExtRef.length == 0) continue;

        let extDataRef = fndExtRef[0];
        if (extDataRef["tempFile"] != null // tempFile means new attachment
          && extDataRef.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            let titleCtrl: IcecontrolSettings = <IcecontrolSettings>this.newAttachmentTitle[chge.medical_service_key][extDataRef.external_data_key];
            if (titleCtrl != null)
              thisAttachment.title = titleCtrl.getFormControl().value;

            if (thisAttachment.title.length == 0)
              thisAttachment.title = thisAttachment.original_path;

            let dateCtrl: IcecontrolSettings = <IcecontrolSettings>this.newAttachmentDate[chge.medical_service_key][extDataRef.external_data_key];
            if (dateCtrl != null)
              thisAttachment.external_reference_date = Iceutility.convertToUTCEx(dateCtrl.getFormControl().value)

            let proCtrl: IcecontrolSettings = <IcecontrolSettings>this.newAttachmentProvider[chge.medical_service_key][extDataRef.external_data_key];
            if (proCtrl != null) {
              try {
                let proObj = JSON.parse(proCtrl.getFormControl().value);
                if (proObj != null && proObj.length > 0) {
                  thisAttachment.provider_trans_account = proObj[0].value;
                }
                else {
                  throw "No provider selected or error saving provider.";
                }
              }
              catch (e) {
                this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, e);
              }
            }

            let docStatusCtrl: IcecontrolSettings = <IcecontrolSettings>this.newAttachmentDocumentStatus[chge.medical_service_key][extDataRef.external_data_key];
            if (docStatusCtrl != null)
              thisAttachment.note_status_type = docStatusCtrl.getFormControl().value;
 
            let typeCtrl: IcecontrolSettings = <IcecontrolSettings>this.newAttachmentType[chge.medical_service_key][extDataRef.external_data_key];
            if (typeCtrl != null)
              thisAttachment.src_type = typeCtrl.getFormControl().value;

            chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

            this.domainSvc.insertDocument(api, thisAttachment.trans_account, thisAttachment, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                let newAttachment = data[0];

                this.domainSvc.insertFile(api, newAttachment.trans_account, newAttachment.external_data_key, newAttachment.parent_src_type, extDataRef["tempFile"], this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
                  filedata => {
                    if (filedata == null || filedata.length == 0) return;

                    // Reset;
                    extDataRef["tempFile"] = null;
                    delete extDataRef["tempFile"];

                    // done remove attachment from new list of attachments
                    thisAttachment.offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
                    this.allAttachments.push(newAttachment);

                    this.autoSaveServices([chge]);

                    let atchCtrl: IcecontrolSettings = this.attachmentSelection[chge.medical_service_key];
                    let docsOpts = atchCtrl.getOptions();

                    let docDt = Iceutility.GetLocalDate(newAttachment.external_reference_date);
                    let desc = AccountingService.getSourceType(Iceutility.toLong(newAttachment.src_type)) + " " + newAttachment.title + " Document on "
                      + Iceutility.getDateTextEx(docDt, null, true);

                    docsOpts.push({
                      name: desc,
                      value: newAttachment.external_data_key,
                      time: docDt.getTime()
                    });

                    docsOpts.sort((a, b) => {
                      let aV: number = a["time"];
                      let bV: number = b["time"];
                      return bV - aV;
                    });

                    atchCtrl.setOptions(docsOpts);
                  },
                  fileerror => {
                    // To do, log error
                  });
              },
              error => {
                // To do, log error
              });
          }
      }
    }
  }

  cancelNewAttachmentsClick(event: any, chge: medicalservice) {
    for (let ifile = 0; ifile < chge.EDOCS.length; ifile++) {
      let extDataRef = chge.EDOCS[ifile];
      if (extDataRef["tempFile"] != null || extDataRef.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
        extDataRef["tempFile"] = null;
        delete extDataRef["tempFile"];
      }
    }
    chge.EDOCS = chge.EDOCS.filter(x => x.offline_record_status != IceTypes.offlineRecStatus.offlineInsert);
    this.newAttachments[chge.medical_service_key] = [];
    this.newAttachmentTitle[chge.medical_service_key] = {};
    this.newAttachmentProvider[chge.medical_service_key] = {};
    this.newAttachmentDocumentStatus[chge.medical_service_key] = {};
    this.newAttachmentType[chge.medical_service_key] = {};
    this.newAttachmentDate[chge.medical_service_key] = {};
 }

  onAttachNewFileSelect(event: any, chge: medicalservice) {
    if (event && event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      let fil: File = event.target.files[0];
      reader.onload = (event) => {
        let usrInfo = this.loginSvc.GetSessionUserInfo();

        if (fil.type != "application/pdf") {
          Iceutility.yesnomodal("This file-type is not allowed for attachments, please use .PDF files.");
          return;
        }
        // create doc file
        let extData: externaldata = new externaldata();
        extData.external_data_key = Iceutility.guid(true);
        extData.trans_account = chge.trans_account;
        extData.parent_src_type = IceTypes.SourceType.srcService;
        extData.src_type = IceTypes.SourceType.srcEncounterNotes;
        extData.note_status_type = IceTypes.notestatus.statusComplete;
        extData.network_trans_account = this.appSvc.getCurrentAccount();
        extData.network_account_type = this.appSvc.getCurrentAccountType();
        extData.original_path = fil["name"];
        extData.external_data_type = this.appSvc.textToExternalTypeText(fil["type"], fil["name"]);

        if (this.newAttachments[chge.medical_service_key] == null)
          this.newAttachments[chge.medical_service_key] = [];

        this.newAttachments[chge.medical_service_key].push(extData);

        // create ref  
        let extDataRef: externaldatareference = new externaldatareference();
        extDataRef.external_data_reference_key = Iceutility.guid(true);
        extDataRef.external_data_key = extData.external_data_key;
        extDataRef.parent_src_type = extData.parent_src_type;
        extDataRef.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
        extDataRef["tempFile"] = fil;
        chge.EDOCS.push(extDataRef);

        if (this.submitNewAttachment[chge.medical_service_key] == null)
          this.submitNewAttachment[chge.medical_service_key] = new IcecontrolSettings("icebutton", { width: "50px", text: "Submit" }, null, null, "submitServiceAttachment_" + chge.medical_service_key);

        if (this.cancelNewAttachment[chge.medical_service_key] == null)
          this.cancelNewAttachment[chge.medical_service_key] = new IcecontrolSettings("icebutton", { width: "50px", text: "Cancel" }, null, null, "submitServiceAttachment_" + chge.medical_service_key);
      };

      reader.onprogress = (event) => {
        debugger; // To do update status of upload
      };

      reader.onloadend = (event) => {
        debugger;
      };
      reader.readAsDataURL(event.target.files[0]); // read file as data url
    }
  }

  addCommentClick(event, chge: medicalservice): void {
    this.domainSvc.getMembersList(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
      data => {
        if (data && data.length > 0) {
          let msg: message = new message();
          msg.message_key = Iceutility.guid(true);
          //msg.parent_message_key = XXX for reply;
          msg.message_date = Iceutility.GetDateText(Iceutility.GetLocalDate(), null, true);
          msg.trans_account = this.serviceCharges.to_trans_account;
          msg.account_type = this.serviceCharges.to_account_type;
          msg.message_status = IceTypes.trans_status.isReadyToSend;
          msg.trans_type = IceTypes.TRANSTYPE.itNone;

          let userInfo = this.loginSvc.GetSessionUserInfo();
          if (Iceutility.isdefined(userInfo))
            msg.from = userInfo.Username;

          msg.subject = chge.service_description + " on " + this.getServiceDates(chge);
          let msgref: messagereference = new messagereference(null);
          msgref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
          this.messageSvc.doMessagePopup(this.dialog, "Add Comment", msg, msgref, data).subscribe(result => {
            if (this.processMessage(result, chge) == true) {              
              this.messageSvc.sendMessage(msg, this.navSvc).subscribe(data => {
                // display message
                this.listOfMessages.push(msg);
                msgref.message_reference_key = Iceutility.guid(true);
                msgref.copy(msg);
                chge.MSGS.push(msgref);
                this.autoSaveServices([chge]);
              }, error => {
                console.log(error);
              });
            }
          });
        }
      },
      error => {
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
  }

  editCommentClick(event, chge: medicalservice, comment: message): void {
    this.domainSvc.getMembersList(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
      data => {
        if (data && data.length > 0) {
          let fndMsgRef = chge.MSGS.filter(r => r.message_key == comment.message_key);
          if (fndMsgRef.length > 0) {
            this.messageSvc.doMessagePopup(this.dialog, "Edit Comment", comment, fndMsgRef[0], data).subscribe(result => {
              if (this.processMessage(result, chge) == true) {
                this.messageSvc.updateMessage(comment, this.navSvc).subscribe(data => {
                  fndMsgRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
                  this.autoSaveServices([chge]);
                }, error => {
                  console.log(error);
                });
              }
            });
          }
        }
      },
      error => {
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
  }

  deleteCommentClick(event, chge: medicalservice, comment: message): void {
    if (Iceutility.yesnomodal("Would you like to remove this comment?")) {
      this.messageSvc.deleteMessage(comment, IceTypes.MessageboxTypes.mboxSENT, this.navSvc).subscribe(data => {
        let fndMsgRef = chge.MSGS.filter(r => r.message_key == comment.message_key);
        if (fndMsgRef.length > 0) {
          chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          fndMsgRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
          this.autoSaveServices([chge]);
        }
      }, error => {
        console.log(error);
      });
    }
  }

  onAddProviderClick(event, chge: medicalservice): void {
    let proref: provider_reference = new provider_reference(null);
    proref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.proSvc.doProviderPopup(this.dialog, this.networkProviders, chge, proref).subscribe(result => {
      if (this.proSvc.processProvider(result) == true) {
        let fndPro = this.networkProviders.filter(p => p.trans_account == proref.trans_account);
        if (fndPro.length > 0) {
          // save provider
          chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          proref.provider_reference_key = Iceutility.guid(true);
          proref.account_type = IceTypes.ACCOUNT_TYPE.actProvider;
          chge.PROS.push(proref);
          this.autoSaveServices([chge]);

          let ctrl: IcecontrolSettings = this.providersListCtrl[chge.medical_service_key];
          let dispName = fndPro[0].getdisplayname(false);
          let fndProCode = this.proSvc.providerCodeOrEntityOptions.filter(c => c.value == proref.provider_code);
          if (fndProCode.length > 0) {
            dispName += " (" + fndProCode[0].name + ")";
          }
          ctrl.getOptions().push({ name: dispName, value: fndPro[0].trans_account });
        }
      }
    });
  }

  onProviderClick(event, chge: medicalservice): void {
    if (chge == null || event.item == null || event.action == null) return;

    let fndProRef = chge.PROS.filter(p => p.trans_account == event.item.value);
    if (fndProRef.length > 0) {
      let proref = fndProRef[0];
      if (event.action.value == IceTypes.recordQuickActionRemove.value) {
        if (Iceutility.yesnomodal("Would you like to remove this provider?")) {
          chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          fndProRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
          this.autoSaveServices([chge]);
          let ctrl: IcecontrolSettings = this.providersListCtrl[chge.medical_service_key];
          let fndOptsToKeep = ctrl.getOptions().filter(o => o.value != fndProRef[0].trans_account);
          ctrl.setOptions(fndOptsToKeep);
        }
      }
      else if (event.action.value == IceTypes.recordQuickActionEdit.value) {
        this.proSvc.doProviderPopup(this.dialog, this.networkProviders, chge, proref).subscribe(result => {
          if (this.proSvc.processProvider(result) == true) {
            let fndPro = this.networkProviders.filter(p => p.trans_account == proref.trans_account);
            if (fndPro.length > 0) {
              // save provider
              chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
              proref.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
              this.autoSaveServices([chge]);
              this.setProviderListControlOption(chge, proref);
            }
          }
        });
      }
    }
  }

  editService(event, chge: medicalservice): void {
    if (chge == null) return;

    this.currentCharge[chge.medical_service_key] = chge;
    this.initializeCurrentChargePanel(event);
  }

  statusChange(event, chge: medicalservice): void {
    let ctrlStatus: IcecontrolSettings = <IcecontrolSettings>this.status[chge.medical_service_key];
    if (ctrlStatus == null) return;

    chge.trans_status = ctrlStatus.getFormControl().value;
    chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    this.autoSaveServices([chge]);
  }

  itemDescChange(event, chge: medicalservice): void {
    let ctrlItemDesc: IcecontrolSettings = <IcecontrolSettings>this.itemDesc[chge.medical_service_key];
    if (ctrlItemDesc == null) return;

    chge.service_description = ctrlItemDesc.getFormControl().value;
    chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    this.autoSaveServices([chge]);
  }

  billToSelectChange(event, chge: medicalservice): void {
    let thisPartyBucketKey = event.value;

    this.initializePartyBuckets(thisPartyBucketKey, <IcecontrolSettings>event.selectSettings);

    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];
      let partyBucketKey = "";
      let ctrlBillItemTo: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
      if (ctrlBillItemTo != null) {
        partyBucketKey = ctrlBillItemTo.getFormControl().value;

        if (chge.medical_service_key == charge.medical_service_key) {
          AccountingService.setServiceSubscriberFromDDLKey(ctrlBillItemTo, charge);
          chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          this.autoSaveServices([chge]);
        }
      }
      if (this.partyBuckets[partyBucketKey] == null) continue;

      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
      let frmCtrlDue = ctrlDue.getFormControl();
      if (frmCtrlDue) {
        this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrlDue.value);
      }
    }
  }

  noteChange(event, chge: medicalservice): void {
    let ctrlNote: IcecontrolSettings = <IcecontrolSettings>this.note[chge.medical_service_key];
    if (ctrlNote == null) return;

    chge.additional_note = ctrlNote.getFormControl().value;
    chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    this.autoSaveServices([chge]);
  }

  diagChange(event) {
    let ctrl: IcecontrolSettings = event.selectSettings;
    if (ctrl == null) return;

    let pointerSync: Function = (dxKey, pointerRef) => {
      let fndDiagOpt = diagOptions.filter(o => o.value == dxKey);
      if (fndDiagOpt.length > 0) {
        let fndDiagObjects = this.allDiagnoses.filter(dx => dx.diagnosis_key == dxKey);
        if (fndDiagObjects.length > 0) {
          if (this.serviceCharges.DIAGS.length == 0) {
            // allocate diags
            this.serviceCharges.DIAGS = [];
            for (let idx = 0; idx < diagCount; idx++) {
              this.serviceCharges.DIAGS.push(new diagnosisreference());
            }
          }
          else if (pointerRef >= this.serviceCharges.DIAGS.length) {
            for (let idx = 0; idx < diagCount; idx++) {
              let dx = this.serviceCharges.DIAGS[idx];
              if (dx == null) this.serviceCharges.DIAGS[idx] = new diagnosisreference();
            }
          }
          this.serviceCharges.DIAGS[pointerRef].diagnosis_key = fndDiagObjects[0].diagnosis_key;
          this.serviceCharges.DIAGS[pointerRef].icd_code = fndDiagObjects[0].icd_code;
          this.serviceCharges.DIAGS[pointerRef].title = fndDiagObjects[0].title;
        }
        else {
          this.serviceCharges.DIAGS[pointerRef].diagnosis_key = "";
          this.serviceCharges.DIAGS[pointerRef].icd_code = "";
          this.serviceCharges.DIAGS[pointerRef].title = "";
        }
      }
    };

    let diagOptions = ctrl.getOptions();
    // change to use diag.key
    switch (ctrl.id) {
      case "Diag1": {
        pointerSync(event.value, this.pointerOne);
        break;
      }
      case "Diag2": {
        pointerSync(event.value, this.pointerTwo);
        break;
      }
      case "Diag3": {
        pointerSync(event.value, this.pointerThree);
        break;
      }
      case "Diag4": {
        pointerSync(event.value, this.pointerFour);
        break;
      }
      case "Diag5": {
        pointerSync(event.value, this.pointerFive);
        break;
      }
      case "Diag6": {
        pointerSync(event.value, this.pointerSix);
        break;
      }
      case "Diag7": {
        pointerSync(event.value, this.pointerSeven);
        break;
      }
      case "Diag8": {
        pointerSync(event.value, this.pointerEight);
        break;
      }
    }

    let code = event.value;
    for (let svc = 0; svc < this.chargeList.length; svc++) {
      let charge = this.chargeList[svc];
      this.setPointers(charge, true, true);
    }

    this.serviceCharges.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    this.autoSaveBucket();
  }

  diagPointerChange(event, chge: medicalservice): void {
    let ptrCtrl: IcecontrolSettings = this.diagPointers[chge.medical_service_key];
    let selectedDiagRefs = null;
    try {
      selectedDiagRefs = JSON.parse(ptrCtrl.getFormControl().value);
      if (selectedDiagRefs != null) {
        let diagRefs = [];
        let fndMREF = this.serviceCharges.CHARGES.filter(x => x.medical_service_key == chge.medical_service_key);
        if (fndMREF.length > 0) {
          let mrefSvc: medicalservicereference = fndMREF[0];
          for (let iopt = 0; iopt < selectedDiagRefs.length; iopt++) {
            let opt = selectedDiagRefs[iopt];
            let fndDiagRef = this.serviceCharges.DIAGS.filter(d => d.diagnosis_key == opt.value);
            if (fndDiagRef.length > 0) {
              diagRefs.push(fndDiagRef[0]);
            }
          }
          mrefSvc.DIAGREFS = diagRefs;
          this.serviceCharges.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          this.autoSaveBucket();
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  modifierChange(event, chge: medicalservice): void {
    try {
      let modCtrl: IcecontrolSettings = this.modifiers[chge.medical_service_key];
      let modObjs = JSON.parse(modCtrl.getFormControl().value);
      if (modObjs != null) {
        chge.modifier1 = "";
        chge.modifier2 = "";
        chge.modifier3 = "";
        chge.modifier4 = "";
        for (let imod = 0; imod < modObjs.length; imod++) {
          let mod = modObjs[imod];
          switch (imod) {
            case 0:
              chge.modifier1 = mod.value;
              break;
            case 1:
              chge.modifier2 = mod.value;
              break;
            case 2:
              chge.modifier3 = mod.value;
              break;
            case 3:
              chge.modifier4 = mod.value;
              break;
          }
        }
        chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
        this.autoSaveServices([chge]);
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  onProblemListUpdate(event): void {
    if (event == null || event.length == 0) return;

    let diag: diagnosis = <diagnosis>event[0];
    let diagOptions = this.diag4Ctrl.getOptions();
    // change to use diag.key
    let fndOpt = diagOptions.filter(o => o.value == diag.diagnosis_key);
    if (fndOpt.length > 0) {
      let icdText = diag.icd_code + " - " + diag.title;
      fndOpt[0].name = icdText;
    }
    else {
      diagOptions.push({ value: diag.diagnosis_key, name: diag.icd_code + " - " + diag.title, code: diag.icd_code });
    }

    this.diag1Ctrl.setOptions(diagOptions);
    this.diag2Ctrl.setOptions(diagOptions);
    this.diag3Ctrl.setOptions(diagOptions);
    this.diag4Ctrl.setOptions(diagOptions);
    this.diag5Ctrl.setOptions(diagOptions);
    this.diag6Ctrl.setOptions(diagOptions);
    this.diag7Ctrl.setOptions(diagOptions);
    this.diag8Ctrl.setOptions(diagOptions);

    for (let svc = 0; svc < this.chargeList.length; svc++) {
      let charge = this.chargeList[svc];
      this.setPointers(charge, false, true);
    }
  }

  onEncounterListUpdate(event): void {
    if (event == null || event.length == 0) return;

    let enc: encounter = <encounter>event[0];
  }

  addItemClick(event): void {
    this.newCharge = new medicalservice();
    this.newCharge.inc_coa_type = IceTypes.coa_types.coaServiceIncome;
    this.initializeCurrentChargePanel(event);
    if (this.listOfServices.length == 0) {
      this.acctSvc.getBillTemplates(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges.to_account_type, "").subscribe(
        billTemplates => {
          if (billTemplates == null || billTemplates.length == 0) {
            return;
          }

          for (let i = 0; i < billTemplates.length; i++) {
            let tempidx: superbillindex = billTemplates[i];
            if (tempidx == null) continue;

            this.acctSvc.getBillTemplate(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), tempidx.superbill_key).subscribe(
              superbillData => {
                if (superbillData && superbillData.length > 0) {
                  let superbill = superbillData[0],
                    subtypes = superbill.SUBTYPES;

                  for (var isubtype = 0; isubtype < subtypes.length; isubtype++) {
                    let subtype = subtypes[isubtype];
                    if (subtype == null) continue;

                    let srcMapKey = subtype.src_type,
                      codes = subtype.CODES;

                    for (var icode = 0; icode < codes.length; icode++) {
                      let code: basecodereference = codes[icode];
                      if (code == null) continue;

                      let obj = {
                        value: code.code,
                        name: code.title,
                        code: code.code,
                        price: code.price,
                      };
                      this.listOfServices.push(obj);
                    }
                  }
                }
              },
              error => {
                console.log(JSON.stringify(this.acctSvc.getLastErrors()));
              });
          }
        }, error => {
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });
    }

    if (this.listOfInventory.length == 0) {
      this.acctSvc.getOtherItems(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "*" /*all*/).subscribe(
        data => {
          if (data == null || data.length == 0) {
            return;
          }
          for (let iresult = 0; iresult < data.length; iresult++) {
            let item: otheritemsindex = data[iresult];

            let obj = {
              value: item.item_stock_num,
              name: item.itm_name,
              code: item.item_stock_num,
              price: item.price,
              key: item.other_items_key
            };
            this.listOfInventory.push(obj);
          }
        },
        error => {
          // To do, log error
        });
    }
  }

  initializeCurrentChargePanel(event: any) {
    setTimeout(() => {
      if (this.currentChargePanel != null) {
        if (this.currentChargePanel.getInitializeEvent() != null) {
          this.currentChargePanel.getInitializeEvent().emit(event);
        }
      }
    });
  }

  onAddItemDoneClick(event): void {
    this.newCharge.trans_account = this.serviceCharges.to_trans_account;
    this.newCharge.account_type = this.serviceCharges.to_account_type;
    this.acctSvc.insertServices(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.newCharge).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let newSvc: medicalservice = data[0];
          this.addChargeToList(newSvc);

          let chrgRef: medicalservicereference = new medicalservicereference();
          chrgRef.medical_service_reference_key = Iceutility.guid(true);
          chrgRef.medical_service_key = newSvc.medical_service_key;
          this.serviceCharges.CHARGES.push(chrgRef);
          this.serviceCharges.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          this.autoSaveBucket();

          if (event.addContinue) {
            this.newCharge = new medicalservice();
            this.newCharge.trans_account = this.serviceCharges.to_trans_account;
            this.newCharge.account_type = this.serviceCharges.to_account_type;
            this.newCharge.inc_coa_type = IceTypes.coa_types.coaServiceIncome;
            this.initializeCurrentChargePanel(event);
          }
        }
      },
      error => {
        console.log(error);
      });

    this.newCharge = null;
  }

  onAddItemCancelClick(event): void {
    this.newCharge = null;
  }

  onItemDoneClick(event, chge: medicalservice): void {
    let curDom = this.appSvc.getCurrentAccount();
    let curDomType = this.appSvc.getCurrentAccountType();
    this.currentCharge[chge.medical_service_key] = null;

    this.initializePartyBuckets("", <IcecontrolSettings>event.selectSettings);

    let ctrlQty: IcecontrolSettings = this.quantity[chge.medical_service_key];
    ctrlQty.getFormControl().setValue(chge.quantity);

    let ctrlAmt: IcecontrolSettings  = this.unitAmount[chge.medical_service_key];
    ctrlAmt.getFormControl().setValue(chge.price);

    let ctrlTtl: IcecontrolSettings = this.totalAmount[chge.medical_service_key];
    ctrlTtl.getFormControl().setValue(chge.total_amount);

    let ctrlAmtDue: IcecontrolSettings = this.amountDue[chge.medical_service_key];
    ctrlAmtDue.getFormControl().setValue(chge.total_amount); // copy to total since this is a computed field from journals

    // Sum of Bucket
    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];
      let partyBucketKey = "";
      let ctrlBillItemTo: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
      if (ctrlBillItemTo != null) {
        partyBucketKey = ctrlBillItemTo.getFormControl().value;
      }
      if (this.partyBuckets[partyBucketKey] == null) continue;

      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
      let frmCtrlDue = ctrlDue.getFormControl();
      if (frmCtrlDue) {
        this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrlDue.value);
      }
    }
    chge.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    this.autoSaveServices([chge]);
  }

  onItemCancelClick(event, chge: medicalservice): void {
    this.currentCharge[chge.medical_service_key] = null;
  }

  benefitsClick(event): void {
    // To do let's only do this for provider when patient has payer/coverage, also open the provider and patient below redirected
    let phrUrl = this.domainSvc.getEHR_PHRUrl();
    let url = this.navSvc.buildRoute(phrUrl + "ListOfBenefits?domain=" + this.serviceCharges.to_trans_account, true, this.serviceCharges.from_trans_account, this.serviceCharges.from_account_type, this.serviceCharges.to_trans_account, userTypes.productCodes.pcEHR);
    if (currentEnv == "local")
      location.href = url;
    else
      window.open(url, "_blank");
  }

  submitItemClick(event): void {

  }

  doneClick(event): void {
    // To do save service
    //this.autoSaveServices([chge]);

    // To do bucket
    //this.autoSaveBucket([chge]);


    this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
  }

  continueClick(event): void {
    // Reset outstanding globals
    this.totalDue = 0.0;
    this.totalTax = 0.0;
    this.payPost = null;

    this.serviceCharges.bill_status = this.billToStatus.getFormControl().value;
    if (this.isPatient()) {
      // change to use diag.key
      let fndDiagOpt = this.diag1Ctrl.getOptions().filter(o => o.value == this.diag1Ctrl.getFormControl().value);
      if (fndDiagOpt.length > 0) {
        if (this.serviceCharges.DIAGS.length >= 1) {
          this.serviceCharges.DIAGS[0].icd_code = fndDiagOpt[0].code;
        }
        else {
          let diagRef = new diagnosisreference();
          diagRef.icd_code = fndDiagOpt[0].code;
          this.serviceCharges.DIAGS.push(diagRef);
        }
      }

      fndDiagOpt = this.diag2Ctrl.getOptions().filter(o => o.value == this.diag2Ctrl.getFormControl().value);
      if (fndDiagOpt.length > 0) {
        if (this.serviceCharges.DIAGS.length >= 2) {
          this.serviceCharges.DIAGS[1].icd_code = fndDiagOpt[0].code;
        }
        else {
          let diagRef = new diagnosisreference();
          diagRef.icd_code = fndDiagOpt[0].code;
          this.serviceCharges.DIAGS.push(diagRef);
        }
      }

      fndDiagOpt = this.diag3Ctrl.getOptions().filter(o => o.value == this.diag3Ctrl.getFormControl().value);
      if (fndDiagOpt.length > 0) {
        if (this.serviceCharges.DIAGS.length >= 3) {
          this.serviceCharges.DIAGS[2].icd_code = fndDiagOpt[0].code;
        }
        else {
          let diagRef = new diagnosisreference();
          diagRef.icd_code = fndDiagOpt[0].code;
          this.serviceCharges.DIAGS.push(diagRef);
        }
      }

      fndDiagOpt = this.diag4Ctrl.getOptions().filter(o => o.value == this.diag4Ctrl.getFormControl().value);
      if (fndDiagOpt.length > 0) {
        if (this.serviceCharges.DIAGS.length >= 4) {
          this.serviceCharges.DIAGS[3].icd_code = fndDiagOpt[0].code;
        }
        else {
          let diagRef = new diagnosisreference();
          diagRef.icd_code = fndDiagOpt[0].code;
          this.serviceCharges.DIAGS.push(diagRef);
        }
      }
    }

    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];

      let ctrlStatus: IcecontrolSettings = <IcecontrolSettings>this.status[charge.medical_service_key];
      if (ctrlStatus == null) continue;
      let frmCtrlStatus = ctrlStatus.getFormControl();
      if (frmCtrlStatus == null) continue;
      charge.trans_status = frmCtrlStatus.value;

      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
      let frmCtrlDue = ctrlDue.getFormControl();
      if (frmCtrlDue) {
        this.totalDue += Iceutility.toDouble(frmCtrlDue.value);
      }

      let ctrlItemDesc: IcecontrolSettings = <IcecontrolSettings>this.itemDesc[charge.medical_service_key];
      if (ctrlItemDesc == null) continue;

      if (ctrlItemDesc.getFormControl().dirty) {
        charge.service_description = ctrlItemDesc.getFormControl().value;
      }

      let ctrlNote: IcecontrolSettings = <IcecontrolSettings>this.note[charge.medical_service_key];
      if (ctrlNote != null) {
        charge.additional_note = ctrlNote.getFormControl().value;
      }

      let ctrlBillItemTo: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
      if (ctrlBillItemTo != null) {
        AccountingService.setServiceSubscriberFromDDLKey(ctrlBillItemTo, charge);
      }

      charge.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;

      let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[charge.medical_service_key];
      let frmCtrlPaid = ctrlPaid.getFormControl();
      if (frmCtrlPaid) {
        // Create payment object and keep in memory until
        let postDate = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
        let refNum = "";
        let svcKey = charge.medical_service_key;
        let amtPaid = frmCtrlPaid.value;

        let postings = this.getNewPostings(charge);
        if (amtPaid == 0.0 && postings == null) {
          switch (frmCtrlStatus.value) {
            case IceTypes.trans_status.isReadyToPrint:
            case IceTypes.trans_status.isReadyToSend: {
              // pass through
              break;
            }
            default:
              continue;
          }
        }

        if (this.payPost == null) {
          this.payPost = new payment();
          this.payPost.trans_account = this.serviceCharges.to_trans_account;
          this.payPost.account_type = this.serviceCharges.to_account_type;
          this.payPost.billed_to = this.serviceCharges.bill_to;
          this.payPost.pay_date = postDate;
        }
        else {
          // we may want to reset all svc pay refs here
        }

        if (amtPaid > 0.0) { // add the default amt paid to the payment to post
          let svcref: servicepaymentreference = null;
          // to do remove this as it could now cause a overwrite of a service pay ref record 
          let foundOrdSvc = this.payPost.SERVICES.filter(s => s.medical_service_key == svcKey);
          if (foundOrdSvc.length == 0) {
            svcref = new servicepaymentreference();
            svcref.service_reference_key = Iceutility.guid(true);
            svcref.medical_service_key = svcKey;
            this.payPost.SERVICES.push(svcref);
          }
          else {
            svcref = foundOrdSvc[0];
          }
          svcref.description = charge.service_description;
          svcref.subscriber_key = charge.subscriber_key;
          svcref.coverage_key = charge.coverage_key;
          svcref.payer_key = charge.payer_key;
          svcref.amount = amtPaid;
          svcref.coa_type = charge.inc_coa_type == IceTypes.coa_types.coaCoPayIncome ? IceTypes.coa_types.coaCoPayAR : IceTypes.coa_types.coaAR;
        }
        // iterate postings and collect the service pay ref's to the payment to post
        for (let ipy = 0; postings != null && ipy < postings.length; ipy++) {
          let pypost = postings[ipy];
          for (let isvcref = 0; isvcref < pypost.SERVICES.length; isvcref++) {
            let svcref = pypost.SERVICES[isvcref];
            this.payPost.SERVICES.push(svcref);
          }
        }
      }
    }

    // Update services now
    this.acctSvc.updateServices(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.chargeList).subscribe(
      svcData => {
          // Do this for done, continue and pay now
          this.acctSvc.updateBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges).subscribe(
            data => {
              if (this.chargeList.length > 0) {
                if (this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient) {
                  this.step = csCGL;
                }
                else {
                  if (this.payPost == null || this.payPost.SERVICES.length == 0) {
                    this.step = csSummary;
                  }
                  else {
                    this.initializePaymentControl();
                    this.step = csPayment;
                  }
                }
                this.currentCGL = 0;
              }
            },
            error => {
              console.log(error);
            });
      },
      error => {
        console.log(error);
      });
  }

  // Search current payment posting and collect them into one payment based on reference_num, cash_coa_type, and paytype (CC/ACH/CASH)
  checkForPayNewPaymentPostings(): payment {
    return null;
  }

  initializePaymentControl(): void {
    if (this.currencies.length > 0 && (this.currencies[0]["rate"] == "0" || this.currencies[0]["rate"] === 0)) {
      this.currencies[0]["rate"] = 1;
    }

    if (this.currencies.length > 0)
      this.paymentCtrl.properties.defaultCountry = this.countries[0].code;
    else
      this.paymentCtrl.properties.defaultCountry = "USA";

    if (this.currencies.length > 0)
      this.paymentCtrl.properties.defaultCurrency = this.currencies[0].code;
    else
      this.paymentCtrl.properties.defaultCurrency = "USD";

    try {


      let opts = [];
      if (this.payPost != null) {
        for (let isvc = 0; isvc < this.payPost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = this.payPost.SERVICES[isvc];
          if (svcref == null) continue;

          let licObj: licenseobject = new licenseobject();
          if (licObj == null) continue;
          licObj.license_id = 1;
          licObj.title = svcref.description;
          licObj.rate = svcref.amount;

          let sub: subscriptionobject = <subscriptionobject>licObj;
          sub.subscription_key = svcref.medical_service_key;
          if (this.currencies.length > 0)
            sub.CURRENCIES.push(this.currencies[0]);
          if (this.countries.length > 0)
            sub.COUNTRIES.push(this.countries[0]);

          // lic condition
          if (Iceutility.toBoolean(licObj.disabled)) continue;

          //if (licObj.account_type == this.appSvc.getCurrentAccountType()) {
          //// filter out countries
          //if (false == this.getDomainService().supportedLicenseCountry(licObj, countries)) {
          //  continue;
          //}

          //// filter out currencies
          //if (false == this.getDomainService().supportedLicenseCurrency(licObj, currencies)) {
          //  continue;
          //}
          // set default lics defaultLics
          //}
          licObj["temp_image"] = "./assets/default_blog_image.png";
          opts.push(licObj);
        }
      }
      this.paymentCtrl.setOptions(opts);

      //if (opts.length > 0) {
      //  // append title caption with  "Click to Buy =>"
      //  this.subTable.showAddButton(true);
      //}
      //else {
      //  this.getDomainService().logMessage(IceTypes.LOGTYPE.ltWarning, "You will need to set your default country and currency to purchase subscriptions.");
      //}

      // Calc payment totals
      this.calculatePaymentTotal(this.paymentCtrl);
    }
    catch (e) {
      console.log(e);
    }
  }

  continueFromCGLClick(event): void {
    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];
      this.autoSaveServices([charge]);
    }

    if (this.payPost != null && this.payPost.SERVICES.length > 0) {
      this.initializePaymentControl();
      this.step = csPayment;
      this.currentCGL = 0;
    }
    else {
      this.step = csSummary;
      this.currentCGL = 0;
      //this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
    }
  }

  backFromCGLClick(event): void {
    // To do save
    // autoSaveServices

    this.step = csBalance;
    this.currentCGL = 0;
  }

  doneFromCGLClick(event): void {
    // To do save
    // autoSaveServices

    this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
  }

  backClick(event): void {
    // To do save
    // autoSaveServices

    if (this.step == csSummary) {
      this.step = csCGL;
    }
    else {
      this.step--;
    }
     
    this.currentCGL = 0;
  }

  printClick(): void {
    window.print();
  }

  claimsClick(event): void {
    this.router.navigate([this.navSvc.buildRoute("accounting/claimsbucket/" + this.serviceCharges.superbill_charges_key, false)]);
  }

  paymentChange(event): void {
    switch (event.buttonSettings.id) {
      case "paymentstatus": {
        let paymentCtrl: IcecontrolSettings = event.buttonSettings;

        switch (event.buttonAction) {
          case "OptionChange": {
            this.calculatePaymentTotal(paymentCtrl);
            break;
          }
        }
        break;
      }
    }
  }

  processOrCancelPayment(event): void {
    let paymentControlGroup: FormGroup = event.paymentGroup;
    if (event.buttonAction == "CancelPayment") {
      this.step = csSummary;
      this.currentCGL = 0;
      this.payPost = null;
      return;
    }

    // 1). To do collect bill payment information
    // 2). then proceed with processBillPayment returns auth code & sends email to group admin (if cash pay)
    // 3). do payment setup, take from this.chargeList and only services selected to pay from accountPayment

    // Collect bill payment information
    let userInfo = this.loginSvc.GetSessionUserInfo();
    let payTrans = new orderobject();
    payTrans.account_type = this.serviceCharges.to_account_type;
    payTrans.login_user_name = this.loginSvc.GetUserName(userInfo, false);

    payTrans.trans_account = this.serviceCharges.to_trans_account;
    payTrans.account_type = this.serviceCharges.to_account_type;
    //payTrans.customer_contact_name = this.profileContactName;
    //payTrans.customer_company_name = this.profileCompanyName;
    //payTrans.customer_address = this.profileAddress;
    //payTrans.customer_city = this.profileCity;
    //payTrans.customer_state = this.profileState;
    //payTrans.customer_postal_code = this.profilePostalCode;
    //payTrans.customer_province = this.profileProvince;
    //payTrans.customer_country_code = this.profileCountryCode;
    //payTrans.customer_phone = this.profilePhone;
    //payTrans.customer_email = this.profileEmail;
    payTrans.customer_currency_code = this.paymentCtrl.properties.defaultCurrency;

    payTrans.sub_total = this.paymentCtrl.properties.subTotal;
    payTrans.other_fees = this.paymentCtrl.properties.otherFees;
    payTrans.total = this.paymentCtrl.properties.grandTotal;
    if (payTrans.PAYMENT_REQUEST == null || payTrans.PAYMENT_REQUEST.length == 0)
      payTrans.PAYMENT_REQUEST = [new paymentrequest()];

    payTrans.PAYMENT_REQUEST[0].transactiontype = "authCaptureTransaction";
    payTrans.PAYMENT_REQUEST[0].paymentmethod = paymentControlGroup.get("paymentMethod").value
    payTrans.PAYMENT_REQUEST[0].cardnumber = paymentControlGroup.get("cardNumber").value;
    payTrans.PAYMENT_REQUEST[0].expirationdate = paymentControlGroup.get("cardExpires").value;
    payTrans.PAYMENT_REQUEST[0].cardcode = paymentControlGroup.get("cardCode").value;
    payTrans.PAYMENT_REQUEST[0].invoicenumber = "";
    payTrans.PAYMENT_REQUEST[0].invoicedescription = "Services rendered";

    let ent = this.payPost.ENTS.length > 0 ? this.payPost.ENTS[0] : null;
    if (ent == null) {
      ent = new entity();
      ent.entity_key = Iceutility.guid(true);
      this.payPost.ENTS.push(ent);
    }

    let actHolder = payTrans.PAYMENT_REQUEST[0].paymentmethod == "0" ? this.serviceCharges.bill_to : paymentControlGroup.get("cardHolder").value;

    if (this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient || this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actSubscriber) {
      let first = "", last = "";
      let parts = actHolder.split(" ");
      if (parts.length > 0)
        first = parts[0];

      if (parts.length > 1)
        last = parts[1];

      payTrans.PAYMENT_REQUEST[0].firstname = first;
      payTrans.PAYMENT_REQUEST[0].lastname = last;
      this.payPost.entity_key = ent.entity_key;
      ent.first_name = first;
      ent.last_name = last;
      ent.entity_identifier_code = IceTypes.entity_type_qualifier.etqPerson;
    }
    else {
      payTrans.PAYMENT_REQUEST[0].nameonaccount = actHolder;
      this.payPost.entity_key = ent.entity_key;
      ent.organization_name = actHolder;
      ent.entity_identifier_code = IceTypes.entity_type_qualifier.etqNonPerson;
    }

    payTrans.PAYMENT_REQUEST[0].bankaccounttype = paymentControlGroup.get("bankAccountType").value;
    payTrans.PAYMENT_REQUEST[0].bankname = paymentControlGroup.get("bankName").value;
    payTrans.PAYMENT_REQUEST[0].bankroutingnumber = paymentControlGroup.get("bankRoutingNumber").value;
    payTrans.PAYMENT_REQUEST[0].bankaccountnumber = paymentControlGroup.get("bankAccountNumber").value;
    payTrans.PAYMENT_REQUEST[0].nameonaccount = paymentControlGroup.get("bankAccountHolder").value;

    let opts: licenseobject[] = this.paymentCtrl.getOptions();
    for (let iLic = 0; iLic < opts.length; iLic++) {
      let licObj: licenseobject = opts[iLic];
      if (licObj == null) continue;

      // lic condition
      if (licObj.license_id != 1) {
        // remove from payment posting because user deselected this one
        let sub: subscriptionobject = <subscriptionobject>licObj;
        this.payPost.SERVICES = this.payPost.SERVICES.filter(s => s.medical_service_key != sub.subscription_key);
      }
      else if (licObj.license_id == 1) {
        // add to payment transaction
        let svcPayDtl: orderdetailobject = new orderdetailobject();
        svcPayDtl.trans_account = this.serviceCharges.to_trans_account;
        svcPayDtl.account_type = this.serviceCharges.to_account_type;
        svcPayDtl.quantity = 1.0;
        svcPayDtl.price = licObj.rate;
        svcPayDtl.summary = licObj.title;

        let sub: subscriptionobject = <subscriptionobject>licObj;
        svcPayDtl.SUBSCRIPTOBJ.push(sub);
        payTrans.ORDER_DETAILS.push(svcPayDtl);
      }
    }

  //  paymentSection.setLoading(true);
  //  paymentSection.setShow(false);

    this.acctSvc.processBillPayment(this.appSvc.getCurrentAccount(),
      this.appSvc.getCurrentAccountType(),
      payTrans).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let ordObj: orderobject = data[0];
            if (ordObj == null) return;
            // get auth code info
            let transRes = null;
            if (transRes == null) {
              try {
                transRes = JSON.parse(ordObj.payment_response);
              }
              catch (e) {
                console.log(e);
              }
            }

            this.payPost.reference_num = transRes != null && transRes.transactionResponse != null ? transRes.transactionResponse.authCode : "";
            this.payPost.total_paid = this.paymentCtrl.properties.grandTotal;
            this.payPost.cash_coa_type = payTrans.PAYMENT_REQUEST[0].paymentmethod == "0" ? IceTypes.coa_types.coaCashPetty : IceTypes.coa_types.coaCashPrimary;

            if (event.dateOfPaymentSettings != null) {
              let dtCtrl: IcecontrolSettings = <IcecontrolSettings>event.dateOfPaymentSettings;
              let dt = dtCtrl.getFormControl().value;
              if (dt != null)
                this.payPost.pay_date = Iceutility.convertToUTCEx(dtCtrl.getFormControl().value);
            }

            // Reset licenses
            this.paymentCtrl.properties.subTotal = 0.0;
            this.paymentCtrl.properties.otherFees = 0.0;
            this.paymentCtrl.properties.grandTotal = 0.0;
            this.paymentCtrl.properties.lastErrors = null;
            for (let iLic = 0; iLic < opts.length; iLic++) {
              let licObj: licenseobject = opts[iLic];
              if (licObj == null) continue;

              licObj.license_id = -1;
            }

            this.acctSvc.postPayment(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.payPost).subscribe(
              data => {
                this.step = csSummary;
                this.currentCGL = 0;
                if (data != null && data.length > 0) {                  
                  let processedPayment: payment = data[0];
                  for (let isvc = 0; isvc < processedPayment.SERVICES.length; isvc++) {
                    let svc = processedPayment.SERVICES[isvc];
                    // remove processed payments
                    let postdata = this.currentChargeHistory.getAllServicePostings(svc.medical_service_key);
                    if (postdata != null) {
                      for (const postkey in postdata) {
                        let thispost: payment = postdata[postkey];
                        if (thispost == null) continue;

                        let keepSvcs = thispost.SERVICES.filter(x => x.service_reference_key != svc.service_reference_key);
                        let noOfSvcChanged = thispost.SERVICES.length != keepSvcs.length;
                        if (noOfSvcChanged) {
                          // remove the service from processing
                          thispost.SERVICES = keepSvcs;
                        }

                        if (noOfSvcChanged && thispost.SERVICES.length == 0) {
                          // all done remove the posting from processing
                          postdata[postkey] = null;
                        }
                      }
                    }

                    this.currentChargeHistory.setServicePosting(svc.medical_service_key, processedPayment.payment_key, processedPayment);
                    this.currentChargeHistory.setServiceAmountDue(svc.medical_service_key, 0.0);
                    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, svc.medical_service_key, IceTypes.coa_types.coaDeductibleAR).subscribe(
                      data => {
                        let charge = null;
                        let foundSvc = this.chargeList.filter(c => c.medical_service_key == svc.medical_service_key);
                        if (foundSvc.length > 0) {
                          charge = foundSvc[0];
                        }
                        else {
                          console.log("");
                          return;
                        }
                       
                        if (data != null) {
                          this.currentChargeHistory.setServiceAssets(charge.medical_service_key, data);
                          let credit = 0.0;
                          for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
                            let jrnl: assetjournal = data[ijrnl];
                            let coatyp = Iceutility.toLong(jrnl.coa_type)
                            if (coatyp == IceTypes.coa_types.coaAR
                              || coatyp == IceTypes.coa_types.coaCoPayAR
                              || coatyp == IceTypes.coa_types.coaCoInsuranceAR
                              || coatyp == IceTypes.coa_types.coaDeductibleAR)
                              credit += Iceutility.toDouble(jrnl.credit);
                          }
                          let ctrl: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
                          let frmCtrl = ctrl.getFormControl();
                          frmCtrl.setValue(Iceutility.toDouble(charge.total_amount) - credit);
                          ctrl.properties.color = frmCtrl.value > 0 ? "red" : "green";

                          // Clear pay amount
                          let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[charge.medical_service_key];
                          let frmCtrlPaid = ctrlPaid.getFormControl();
                          frmCtrlPaid.setValue(0);

                          this.currentChargeHistory.setServiceAmountDue(charge.medical_service_key, frmCtrl.value);
                        }
                      },
                      error => {
                        console.log(error);
                      });

                  }
                  setTimeout(() => {
                    this.totalDue = 0.0;
                    this.initializePartyBuckets(null, null);
                    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                      let charge = this.chargeList[ichrg];
                      let partyBucketKey = AccountingService.getPartyBucketKey(charge);
                      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
                      let frmCtrlDue = ctrlDue.getFormControl();
                      if (frmCtrlDue) {
                        this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrlDue.value);
                        this.totalDue += Iceutility.toDouble(frmCtrlDue.value);
                      }
                    }
                  }, 1000);
                }
                //this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
              },
              error => {
                console.log(error);
              });
          }
        },
        error => {
          console.log(error);
          //      paymentSection.setLoading(false);
          //      paymentSection.setShow(true);

          // First lets do the basic error then try the full object
          let msg = "";
          if (error.statusText != null)
            msg += error.statusText;

          if (error.status != null)
            msg += " (" + error.status + ").";

          msg += "Make sure to complete the payment information using first and last name, and bank card or account information."
          this.acctSvc.logMessage(IceTypes.LOGTYPE.ltError, msg);

          var logrpt = new LogReport();
          var logmsg = new logmessage();
          logmsg.logtype = IceTypes.LOGTYPE.ltError;
          logmsg.message = msg;
          logrpt.LOGS.push(logmsg);
          var logrpts = [logrpt];

          this.paymentCtrl.properties.lastErrors = {
            requestUrl: null,
            logReports: logrpts,
            genericErrors: null
          };

          let errObj = this.acctSvc.getLastErrors();
          if (errObj != null && errObj.logReports != null) {
            try {
              console.log(JSON.stringify(errObj));
              this.paymentCtrl.properties.lastErrors = errObj;
            }
            catch (loge) {
              // fall through
            }
          }
        });
  }

  // Summary Getters
  getCurrentDate(): string {
    return Iceutility.getDateTextEx(Iceutility.GetLocalDate(), null, true);
  }

  getSummaryBillStatus(): string {
    return MessageService.getStatus(Iceutility.toLong(this.serviceCharges.bill_status));
  }

  getServiceDates(charge: medicalservice): string {
    if (charge == null || charge.SVCDTS.length == 0)
      return "";


    let dtFrom = Iceutility.isTextDateTime(charge.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].date_required), null, false);
    let dtTo = Iceutility.isTextDateTime(charge.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].end_date_required), null, false);
    return dtFrom + " - " + dtTo;
  }

  getServiceCode(charge: medicalservice): string {
    if (charge == null)
      return "";

    return charge.code;
  }

  getServiceDescription(charge: medicalservice): string {
    if (charge == null)
      return "";

    return charge.service_description;
  }

  getServiceAdditionalNote(charge: medicalservice): string {
    if (charge == null)
      return "";

    return charge.additional_note;
  }

  getServiceAmountDue(charge: medicalservice): string {
    if (charge == null)
      return "0";

    let ctrl: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
    let frmCtrl = ctrl.getFormControl();
    if (frmCtrl == null) return "0";

    return frmCtrl.value.toString();
  }

  getServiceAmountPaid(charge: medicalservice): string {
    if (charge == null || this.payPost == null)
      return "0";

    let foundOrdSvc = this.payPost.SERVICES.filter(s => s.medical_service_key == charge.medical_service_key);
    if (foundOrdSvc.length == 0) return "0";

    return foundOrdSvc[0].amount.toString();
  }

  getServiceBillTo(charge: medicalservice): string {
    let ctrl: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
    let frmCtrl = ctrl.getFormControl();
    if (frmCtrl == null) return "";
    let foundBillTo = ctrl.getOptions().filter(o => o.value == frmCtrl.value);
    if (foundBillTo.length == 0) return "";

    return foundBillTo[0].name;
  }

  getSummaryTotalTax(): string {
    return Iceutility.toDouble(this.totalTax).toString();
  }

  getSummaryTotalDue(): string {
    return Iceutility.toDouble(this.totalDue).toString();
  }

  getSummaryTotalPaidAmount(): string {
    return this.payPost == null ? "0" : this.payPost.total_paid.toString();
  }

  getSummaryRemainingBalance(): string {
    return this.payPost == null ? Iceutility.toDouble(this.totalDue).toString() : (Iceutility.toDouble(this.totalDue) - Iceutility.toDouble(this.payPost.total_paid)).toString();
  }

  onToolbarMenuItemClick(event) {
    if (Iceutility.isdefined(event) && Iceutility.isdefined(event.selectedItem) && Iceutility.isdefined(event.selectedItem.data)) {
      const account = event.selectedItem.data.account;

      if (this.previousPage.toLocaleLowerCase() === AppConstants.ServiceChargeHistoryPage) {
        this.router.navigate([`/accounting/servicechargehistory/${account}`]);
      } else if (this.previousPage.toLocaleLowerCase() === AppConstants.LedgerPage) {
        this.router.navigate([`/accounting/ledger`]);
      }
    }
  }

  onToolbarMenuItemOpen(event) {
    // To do save
    // autoSaveServices

    if (Iceutility.isdefined(event) && Iceutility.isdefined(event.toolbarItem)) {
      this.router.navigate([event.toolbarItem.link]);
    }
  }

  deleteCharge(event, charge) {
    const foundCharge = this.chargeList.find(ch => ch.medical_service_key === charge.medical_service_key),
      index = this.chargeList.findIndex(ch => ch.medical_service_key === charge.medical_service_key);

    if (Iceutility.isdefined(foundCharge)) {
      let headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px", tooltip: "Delete" }, null, null, "Delete"),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Close" }, null, null, "Close")
      ];

      let sections = [
        new IcepanelsectionSettings("section1", { class: [""], styles: {} }, [],
          [new IcecontrolSettings("icelabel", { width: "200px", value: "Are you sure you want to remove this service charge?" }, null, null)], null)
      ];

      this.deleteConfirmationDialogRef = this.dialog.open(IcepanelDialog, {
        height: '220px',
        width: '550px',
        data: {
          record: {
            charge: foundCharge,
            event
          },
          panel: new IcepanelSettings("", "", "Remove Service Charge?", "", sections, headerControls)
            .enableForm(),
        }
      });

      let dialogRef = this.deleteConfirmationDialogRef;
      this.deleteConfirmationDialogRef.afterClosed().subscribe(result => {
        if (!Iceutility.isdefined(dialogRef.componentInstance) || !Iceutility.isdefined(dialogRef.componentInstance.data)) return;
        let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>dialogRef.componentInstance.data.headerCtrl;
        if (hdrCtrl == null || hdrCtrl.id == "Close") {
          event.source.checked = true;
          event.checked = true;
          return;
        }

        this.loading = true;
        const recordToDelete = dialogRef.componentInstance.data.record.charge;
        const params = {
          itemKey: recordToDelete["medical_service_key"]
        };
        let removeApi = this.acctSvc.billServiceScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.billKey, params);

        removeApi.subscribe(
          data => {
            this.loading = false;
            this.chargeList.splice(index, 1);
          },
          _ => {
            this.showErrorMessage("Failed to remove the item.");
            this.loading = false;
          });

      });
    }
  }

  private showErrorMessage(message: string) {
    this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, message);
    Iceutility.scrollToTop();
  }
}
